webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(374),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return copyToClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userHasRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userHasAnyOfRoles; });
var copyToClipboard = function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    return window.clipboardData.setData('Text', text);
  } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    var textarea = document.createElement('textarea');
    textarea.textContent = text;
    textarea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand('copy'); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
};

var userHasRole = function userHasRole(userRoles, role) {
  if (!userRoles || !role) return false;
  return userRoles.indexOf(role) !== -1;
};

var userHasAnyOfRoles = function userHasAnyOfRoles(userRoles, roles) {
  return userRoles && roles && roles.some(function (role) {
    return userHasRole(userRoles, role);
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  copyToClipboard: copyToClipboard,
  userHasRole: userHasRole,
  userHasAnyOfRoles: userHasAnyOfRoles
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(369),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(250)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(361),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(386),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(248)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(358),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_httpSetup__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios_extensions__ = __webpack_require__(57);




var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  /* global API_URL */
  /* eslint no-undef: "error" */
  baseURL: "https://promohub.punkta.pl",
  headers: { 'Cache-Control': 'no-cache' },
  adapter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_axios_extensions__["a" /* cacheAdapterEnhancer */])(__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.adapter, { enabledByDefault: false })
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_httpSetup__["a" /* jwtAuthSetup */])(http);

/* unused harmony default export */ var _unused_webpack_default_export = ({
  http: http
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(364),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii0yODUgNDA4LjkgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgLTI4NSA0MDguOSAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzFFMzk0QztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KCS5zdDF7ZmlsbDpub25lO30NCjwvc3R5bGU+DQo8ZyBpZD0iT3V0bGluZV9JY29ucyI+DQoJPGc+DQoJCTxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9Ii0yNjcuNSw0MjkuNCAtMjY3LjUsNDMyLjQgLTI4MS41LDQzMi40IC0yODEuNSw0MTIuNCAtMjc4LjUsNDEyLjQgCQkiLz4NCgkJPHBvbHlnb24gY2xhc3M9InN0MCIgcG9pbnRzPSItMjY0LjUsNDI5LjQgLTI3OC41LDQyOS40IC0yNzguNSw0MDkuNCAtMjcwLjUsNDA5LjQgLTI2NC41LDQxNS40IAkJIi8+DQoJCTxwb2x5bGluZSBjbGFzcz0ic3QwIiBwb2ludHM9Ii0yNzAuNSw0MDkuNCAtMjcwLjUsNDE1LjQgLTI2NC41LDQxNS40IAkJIi8+DQoJPC9nPg0KPC9nPg0KPGcgaWQ9IkludmlzaWJsZV9TaGFwZSI+DQoJPHJlY3QgeD0iLTI4NSIgeT0iNDA4LjkiIGNsYXNzPSJzdDEiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(246)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(356),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(281)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(389),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var buildQuery = function buildQuery(query) {
  if (typeof query === 'string') {
    return query;
  }
  var result = [];
  for (var key in query) {
    var itemVal = '';
    var item = query[key];
    if (item === false) continue;
    if (typeof item === 'string') {
      result.push(item);
      continue;
    }
    if (typeof key === 'string') {
      itemVal += key;
    }
    if (item.from) {
      itemVal += ':' + item.from;
    }
    if (item.where) {
      var where = [];
      for (var param in item.where) {
        where.push(param + ':' + item.where[param]);
      }
      itemVal += '(' + where.join(' ') + ')';
    }
    if (item.select) {
      itemVal += buildQuery(item.select);
    } else if (typeof item !== 'string' && !item.select && !item.where && !item.from) {
      itemVal += buildQuery(item);
    }
    result.push(itemVal);
  }
  if (result.length === 0) {
    return '';
  }
  return '{' + result.join(' ') + '}';
};

/* harmony default export */ __webpack_exports__["a"] = ({
  buildQuery: buildQuery
});

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(360),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(399),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(258)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(372),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('date', function (value) {
  if (!value) return '';
  var parseDate = new Date(value);
  var locale = 'pl-PL';
  return parseDate.toLocaleTimeString(locale).slice(0, 5) + ' ' + ('0' + parseDate.toLocaleDateString(locale).replace(/\./g, '-')).slice(-10);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('currency', function (value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  value = Number(value);
  if (isNaN(value)) return '';
  return value.toFixed(precision).replace(/(\d)(?=(\d{3}))/g, '$1 ').replace(/\./g, ',') + ' zł';
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('valToName', function (value, collection) {
  if (!value || !collection) return '';
  return collection.find(function (item) {
    return item.value === value;
  }).name;
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_login__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_register__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_registerAgent__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_registerAgent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_registerAgent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_passForgot__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_passForgot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_passForgot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_passReset__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_passReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_passReset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_confirmEmail__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_confirmEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_confirmEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_checkInbox__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_checkInbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_checkInbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_logoutAgent__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_logoutAgent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_logoutAgent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_dashboard_dashboard__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_dashboard_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_dashboard_dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_dashboard_userInvite__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_dashboard_userInvite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_dashboard_userInvite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_dashboard_accountDetails__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_dashboard_accountDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_dashboard_accountDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_dashboard_yourFunds__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_dashboard_yourFunds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_dashboard_yourFunds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_dashboard_tranches__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_dashboard_tranches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_dashboard_tranches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_dashboard_mails__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_dashboard_mails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_dashboard_mails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_dashboard_processLead__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_dashboard_processLead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_dashboard_processLead__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_dashboard_users__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_dashboard_users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_dashboard_users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_helper__ = __webpack_require__(7);











// dashboard




// accountant



// admin



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_home___default.a
  }, {
    path: '/logowanie',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_login___default.a
  }, {
    path: '/rejestracja',
    name: 'register',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_register___default.a
  }, {
    path: '/rejestracja-agenta',
    name: 'registerAgent',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_registerAgent___default.a
  }, {
    path: '/przypomnienie-hasla',
    name: 'passForgot',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_passForgot___default.a
  }, {
    path: '/potwierdz-email',
    name: 'confirmEmail',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_confirmEmail___default.a
  }, {
    path: '/sprawdz-skrzynke',
    name: 'checkInbox',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_checkInbox___default.a
  }, {
    path: '/resetuj-haslo',
    name: 'passReset',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_passReset___default.a
  }, {
    path: '/konto',
    component: { template: '<router-view></router-view>' },
    children: [{
      path: 'wypelnij-dane',
      name: 'accountDetails',
      component: __WEBPACK_IMPORTED_MODULE_13__pages_dashboard_accountDetails___default.a,
      meta: { auth: true, allowRoles: ['unfilled_account_data'] }
    }, {
      path: '',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_dashboard_dashboard___default.a,
      meta: { auth: true, disallowRoles: ['unfilled_account_data'] }
    }, {
      path: 'narzedzia',
      name: 'tools',
      component: __WEBPACK_IMPORTED_MODULE_12__pages_dashboard_userInvite___default.a,
      meta: { auth: true, disallowRoles: ['accountant', 'unfilled_account_data'] }
    }, {
      path: 'twoje-srodki',
      name: 'yourFunds',
      component: __WEBPACK_IMPORTED_MODULE_14__pages_dashboard_yourFunds___default.a,
      meta: { auth: true, disallowRoles: ['accountant', 'agent'] }
    }, {
      path: 'wyloguj-agenta',
      name: 'logoutAgent',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_logoutAgent___default.a
    },
    /* Accountant roles */
    {
      path: 'transze',
      name: 'tranches',
      component: __WEBPACK_IMPORTED_MODULE_15__pages_dashboard_tranches___default.a,
      meta: { auth: true, allowRoles: ['accountant'] }
    }, {
      path: 'maile',
      name: 'mails',
      component: __WEBPACK_IMPORTED_MODULE_16__pages_dashboard_mails___default.a,
      meta: { auth: true, allowRoles: ['accountant'] }
    }, {
      path: 'pelny-proces',
      name: 'completeProcess',
      component: __WEBPACK_IMPORTED_MODULE_17__pages_dashboard_processLead___default.a,
      meta: { auth: true, allowRoles: ['accountant'] }
    }, {
      path: 'partnerzy',
      name: 'users',
      component: __WEBPACK_IMPORTED_MODULE_18__pages_dashboard_users___default.a,
      meta: { auth: true, allowRoles: ['admin'] }
    }]
  }, { path: '*', redirect: '/' }]
});

router.beforeEach(function (to, from, next) {
  var userRoles = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].store.getters.getUserRoles;
  if (to.meta.auth && !__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].store.getters.isLoggedIn) {
    next({ name: 'login' });
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__services_helper__["a" /* userHasRole */])(userRoles, 'unfilled_account_data') && to.name !== 'accountDetails') {
    next({ name: 'accountDetails' });
  } else if (userRoles && to.meta.allowRoles && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__services_helper__["b" /* userHasAnyOfRoles */])(userRoles, to.meta.allowRoles)) {
    next({ name: 'dashboard' });
  } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__services_helper__["b" /* userHasAnyOfRoles */])(userRoles, to.meta.disallowRoles)) {
    next(false);
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rollbar__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_rollbar__);



var rollbarConfig = {
  accessToken: "53f7ce11e92d4cc0a8080f52d3af2247",
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: "production" === 'production' || "production" === 'staging',
  source_map_enabled: true,
  environment: "production",
  payload: {
    client: {
      javascript: {
        code_version: '1.0'
      }
    }
  }
};

var rollbarInitializer = function rollbarInitializer() {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_rollbar___default.a, rollbarConfig);
};

/* harmony default export */ __webpack_exports__["a"] = (rollbarInitializer);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_account__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_statistics__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_tranches__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_users__ = __webpack_require__(142);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  state: {},
  modules: {
    statistics: __WEBPACK_IMPORTED_MODULE_4__modules_statistics__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    account: __WEBPACK_IMPORTED_MODULE_3__modules_account__["a" /* default */],
    tranches: __WEBPACK_IMPORTED_MODULE_5__modules_tranches__["a" /* default */],
    users: __WEBPACK_IMPORTED_MODULE_6__modules_users__["a" /* default */]
  }
}));

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(267)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(383),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_charts__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_rollbar__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_materialize_css_dist_js_materialize__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_materialize_css_dist_js_materialize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_materialize_css_dist_js_materialize__);











// import './materialize'

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_rollbar__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].store = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_charts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
document.addEventListener('DOMContentLoaded', function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
  });
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return jwtAuthSetup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);



var jwtAuthSetup = function jwtAuthSetup(instance) {
  instance.interceptors.request.use(function (config) {
    var token = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].store.getters.getToken || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
  });

  instance.interceptors.response.use(function (response) {
    if (response.data && response.data.token) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].store.commit('STORE_TOKEN', response.data.token);
    }
    return response.data;
  }, function (error) {
    if (error.response.status === 401 && __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].store.getters.getToken) {
      var originalRequest = error.config;
      if (canRepeatRequest(originalRequest)) {
        return refreshTokenAndRepeatRequest(instance, originalRequest);
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].store.dispatch('logout');
      }
    } else if (isBadServerResponse(error)) {
      error.response = normalizeErrorResponse(error.response, 'Wystąpił nieoczekiwany błąd aplikacji...');
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
};

var normalizeErrorResponse = function normalizeErrorResponse(response, message) {
  message = message || response.data.error;
  if (message) {
    response.data = {
      errors: { message: [message] },
      code: response.status
    };
  }
  return response;
};

var canRepeatRequest = function canRepeatRequest(request) {
  var isRefreshTokenPending = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].store.getters.isRefreshTokenPending;
  return (!request._retry || isRefreshTokenPending) && request.url.indexOf('/api/token_refreshes') === -1;
};

var refreshTokenAndRepeatRequest = function refreshTokenAndRepeatRequest(instance, request) {
  request._retry = true;
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].store.dispatch('refreshToken').then(function (response) {
    var token = response.token ? response.token : __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].store.getters.getToken;
    request.headers.Authorization = 'Bearer ' + token;
    return instance(request);
  }, function () {
    return instance(request);
  });
};

var isBadServerResponse = function isBadServerResponse(error) {
  return typeof error.response.data === 'string' || !error.response.data.errors;
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  jwtAuthSetup: jwtAuthSetup
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export promoCode */
/* unused harmony export generateTranche */
/* unused harmony export reminderBeneficiaryEmail */
/* unused harmony export processLead */
/* unused harmony export sendAccountDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_http__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_extensions__ = __webpack_require__(57);





var cacheAccountDetails = new __WEBPACK_IMPORTED_MODULE_3_axios_extensions__["b" /* Cache */]();

var getUser = function getUser(_ref, params) {
  var state = _ref.state,
      commit = _ref.commit,
      rootState = _ref.rootState,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* http */].get('/api/user_details', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { cache: cacheAccountDetails })).then(function (response) {
      commit('STORE_USER', response.data.user);
      resolve(response);
    }).catch(function (error) {
      return reject(error.response.data);
    });
  });
};

var promoCode = function promoCode(_ref2) {
  var state = _ref2.state,
      commit = _ref2.commit,
      rootState = _ref2.rootState;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* http */].get('/api/users/promotion', { cache: cacheAccountDetails }).then(function (response) {
      commit('STORE_PROMO_URL', response.data.promo_url);
      commit('STORE_PROMO_WIDGET', response.data.promo_widget);
      commit('STORE_PROMO_MPC', response.data.mpc_code);
      resolve(response);
    }).catch(function (error) {
      return reject(error.response.data);
    });
  });
};

var generateTranche = function generateTranche(_ref3) {
  var state = _ref3.state,
      commit = _ref3.commit,
      dispatch = _ref3.dispatch,
      rootState = _ref3.rootState;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* http */].post('/api/users/generate_tranch').then(function (response) {
      dispatch('statistics/getPaymentSaldo', 'get');
      resolve(response);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

var reminderBeneficiaryEmail = function reminderBeneficiaryEmail(_ref4, email) {
  var state = _ref4.state,
      commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* http */].post('/api/accountants/reminders/beneficiary_payments', { email: email }).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

var processLead = function processLead(_ref5, salesforceId) {
  var state = _ref5.state,
      commit = _ref5.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* http */].post('/api/accountants/reminders/beneficiary_payments_by_sf_ids', { salesforce_id: salesforceId }).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

var sendAccountDetails = function sendAccountDetails(_ref6, data) {
  var state = _ref6.state,
      commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2__services_http__["a" /* http */].post('/api/accounts/update_account_details', data).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: getUser,
  promoCode: promoCode,
  generateTranche: generateTranche,
  reminderBeneficiaryEmail: reminderBeneficiaryEmail,
  processLead: processLead,
  sendAccountDetails: sendAccountDetails
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getUser = function getUser(state) {
  return state.user;
};

var getUserPending = function getUserPending(state) {
  return state.userPending;
};

var getUserRoles = function getUserRoles(state) {
  return state.user.roles;
};

var getPromoUrl = function getPromoUrl(state) {
  return state.promoUrl;
};

var getMpcCode = function getMpcCode(state) {
  return state.mpcCode;
};

var getPromoWidget = function getPromoWidget(state) {
  return state.promoWidget;
};

var getTranches = function getTranches(state) {
  return state.tranches;
};

var getUserSettlementType = function getUserSettlementType(state) {
  return function (type) {
    return type ? state.user.settlement_type[type] : state.user.settlement_type;
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: getUser,
  getUserPending: getUserPending,
  getUserRoles: getUserRoles,
  getPromoUrl: getPromoUrl,
  getMpcCode: getMpcCode,
  getPromoWidget: getPromoWidget,
  getTranches: getTranches,
  getUserSettlementType: getUserSettlementType
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(126);




var namespaced = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: {
    user: {
      settlement_type: {}
    },
    userPending: false,
    promoUrl: '',
    promoWidget: '',
    tranches: {},
    mpcCode: ''
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  STORE_USER: function STORE_USER(state, user) {
    state.user = user;
    state.userPending = false;
  },
  STORE_PROMO_URL: function STORE_PROMO_URL(state, promoUrl) {
    state.promoUrl = promoUrl;
  },
  STORE_PROMO_WIDGET: function STORE_PROMO_WIDGET(state, promoWidget) {
    state.promoWidget = promoWidget;
  },
  STORE_PROMO_MPC: function STORE_PROMO_MPC(state, mpcCode) {
    state.mpcCode = mpcCode;
  },
  USER_PENDING: function USER_PENDING(state, data) {
    state.userPending = data;
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_http__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(129);







var login = function login(_ref, creds) {
  var state = _ref.state,
      commit = _ref.commit,
      rootState = _ref.rootState,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].post('/api/login', creds).then(function (response) {
      commit('AUTH_SUCCESS');
      resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* generateSuccessLoginResponse */])(response));
    }).catch(function (error) {
      return reject(error.response.data);
    });
  });
};

var confirmAuthorizationInB2c = function confirmAuthorizationInB2c(_ref2, _ref3) {
  var state = _ref2.state;
  var email = _ref3.email,
      mpcCode = _ref3.mpcCode;

  var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ email: email, mpcCode: mpcCode });
  var targetOrigin = '*';
  window.opener.postMessage(payload, targetOrigin);
  window.close();
};

var register = function register(_ref4, creds) {
  var state = _ref4.state;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].post('/api/sign_up', creds).then(function (response) {
      return resolve(response);
    }).catch(function (error) {
      return reject(error.response.data);
    });
  });
};

var passForgot = function passForgot(_ref5, creds) {
  var state = _ref5.state;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].post('/api/reset_password', creds).then(function (response) {
      return resolve(response);
    }).catch(function (error) {
      return reject(error.response.data);
    });
  });
};

var passReset = function passReset(_ref6, creds) {
  var state = _ref6.state;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].patch('/api/reset_password', creds).then(function (response) {
      return resolve(response);
    }).catch(function (error) {
      return reject(error.response.data);
    });
  });
};

var confirmEmail = function confirmEmail(_ref7, request) {
  var state = _ref7.state;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].get('/api/confirm_email', { params: request }).then(function (response) {
      return resolve(response);
    }).catch(function (error) {
      return reject(error.response.data);
    });
  });
};

var refreshToken = function refreshToken(_ref8, request) {
  var state = _ref8.state,
      commit = _ref8.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (state.refreshTokenPending) {
      setTimeout(function () {
        resolve({ token: state.token });
      }, 400);
    } else if (!state.token) {
      reject({});
    } else {
      commit('REFRESH_TOKEN_PENDING', true);
      __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].get('/api/token_refreshes', request).then(function (response) {
        commit('STORE_NEW_TOKEN', response.token);
        resolve(response);
      }).catch(function (error) {
        return reject(error.response.data);
      });
    }
  });
};

var authSocial = function authSocial(_ref9, payload) {
  var commit = _ref9.commit,
      dispatch = _ref9.dispatch;

  var oauthPath = __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].defaults.baseURL + '/users/auth/' + payload.provider;

  var queryParamsToJoin = {
    punkta_agent: payload.isBroker || undefined,
    parent_mpc_code: payload.parentMpcCode
  };

  var queryParams = __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(queryParamsToJoin);
  if (queryParams.length) {
    oauthPath += '?' + queryParams;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["b" /* openOauthInSameTabIfNeeded */])(oauthPath);

  var popup = window.open(oauthPath);
  if (popup && popup.focus) {
    popup.focus();
  }

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var receiveMessage = function receiveMessage(event) {
      // security for read message only from api origin
      if (event.origin !== __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* http */].defaults.baseURL) return;

      var token = JSON.parse(event.data).token;
      clearInterval(popupInterval);
      window.removeEventListener('message', receiveMessage, false);
      if (token) {
        commit('STORE_TOKEN', token);
        commit('AUTH_SUCCESS');
        resolve(token);
      } else {
        reject({
          errors: {
            message: ['Auth popup window without token']
          }
        });
      }
    };
    window.addEventListener('message', receiveMessage, false);
    var popupInterval = setInterval(function () {
      if (!popup || popup.closed || popup.closed === undefined) {
        clearInterval(popupInterval);
        popupInterval = null;
        window.removeEventListener('message', receiveMessage, false);
        reject({
          errors: {
            message: ['Auth popup window closed']
          }
        });
      }
    }, 250);
  });
};

var logout = function logout(_ref10) {
  var state = _ref10.state,
      commit = _ref10.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    commit('LOGOUT');
    commit('STORE_USER', {});
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].router.push('/logowanie');
    window.location.reload();
  });
};

var auth = function auth(_ref11) {
  var state = _ref11.state,
      commit = _ref11.commit,
      dispatch = _ref11.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    commit('AUTH_SUCCESS');
    resolve();
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  login: login,
  confirmAuthorizationInB2c: confirmAuthorizationInB2c,
  register: register,
  passForgot: passForgot,
  passReset: passReset,
  confirmEmail: confirmEmail,
  refreshToken: refreshToken,
  authSocial: authSocial,
  logout: logout,
  auth: auth
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isLoggedIn = function isLoggedIn(state) {
  return state.isLoggedIn;
};

var getToken = function getToken(state) {
  return state.token;
};

var isRefreshTokenPending = function isRefreshTokenPending(state) {
  return state.isRefreshTokenPending;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  isLoggedIn: isLoggedIn,
  isRefreshTokenPending: isRefreshTokenPending,
  getToken: getToken
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openOauthInSameTabIfNeeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateSuccessLoginResponse; });
var shouldReturnToOpener = function shouldReturnToOpener() {
  var params = new URLSearchParams(window.location.search);
  return params.get('return_to_opener');
};

// For authorization consultant coming from b2c - we need to have window.opener === b2c
var openOauthInSameTabIfNeeded = function openOauthInSameTabIfNeeded(oauthPath) {
  if (!shouldReturnToOpener()) return;

  window.location.href = oauthPath;
};

var generateSuccessLoginResponse = function generateSuccessLoginResponse(response) {
  if (shouldReturnToOpener()) return { code: response.code, returnToOpener: true, mpcCode: response.mpc_code };

  return response;
};

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(131);




var namespaced = false;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    token: localStorage.getItem('token')
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  STORE_TOKEN: function STORE_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem('token', token);
  },
  AUTH_SUCCESS: function AUTH_SUCCESS(state) {
    state.isLoggedIn = true;
  },
  LOGOUT: function LOGOUT(state) {
    state.isLoggedIn = false;
    state.token = false;
    localStorage.removeItem('token');
  },
  REFRESH_TOKEN_PENDING: function REFRESH_TOKEN_PENDING(state, status) {
    state.refreshTokenPending = status;
  },
  STORE_NEW_TOKEN: function STORE_NEW_TOKEN(state, token) {
    state.lastToken = state.token;
    state.token = token;
    localStorage.setItem('token', token);
    setTimeout(function () {
      state.refreshTokenPending = false;
    }, 5000);
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__ = __webpack_require__(39);




var parseData = function parseData(date) {
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
};

var getAll = function getAll(_ref, method) {
  var state = _ref.state,
      commit = _ref.commit;

  commit('PENDING', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        summary: {
          calculations: ['started', 'completed', 'phone_confirmed', 'sold_policies'],
          payments: { 'saldo': true, 'payout_possibility': { 'from': 'payoff_possibility' } }
        }
      })
    };

    var requestQuery = query;
    if (method === 'get') requestQuery = { params: requestQuery };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */][method]('/api/graphql', requestQuery).then(function (response) {
      commit('SAVE_SUMMARY', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING', false);
      reject(error.response.data);
    });
  });
};
var getPaymentSaldo = function getPaymentSaldo(_ref2, method) {
  var state = _ref2.state,
      commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        summary: {
          payments: { 'saldo': true, 'payout_possibility': { 'from': 'payoff_possibility' } }
        }
      })
    };

    var requestQuery = query;
    if (method === 'get') requestQuery = { params: requestQuery };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */][method]('/api/graphql', requestQuery).then(function (response) {
      commit('SAVE_SALDO', response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

var getCalculationHistory = function getCalculationHistory(_ref3, method) {
  var state = _ref3.state,
      commit = _ref3.commit;

  commit('PENDING_HISTORY', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var currentDate = new Date();
    var fromDate = new Date(currentDate - 10 * 24 * 3600 * 1000);
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        history: {
          where: {
            date_from: '"' + parseData(fromDate) + '"',
            date_to: '"' + parseData(currentDate) + '"'
          },
          select: {
            calculations: {
              started: true,
              completed: true,
              date: true
            }
          }
        }
      })
    };

    var requestQuery = query;
    if (method === 'get') requestQuery = { params: requestQuery };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */][method]('/api/graphql', requestQuery).then(function (response) {
      commit('SAVE_HISTORY', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING_HISTORY', false);
      reject(error.response.data);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: getAll,
  getPaymentSaldo: getPaymentSaldo,
  getCalculationHistory: getCalculationHistory
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getAll = function getAll(state) {
  return state;
};

var getPayment = function getPayment(state) {
  return state.summary.payments;
};

var getPaymentSaldo = function getPaymentSaldo(state) {
  return state.summary.payments.saldo;
};

var getPayoutPossibility = function getPayoutPossibility(state) {
  return state.summary.payments.payout_possibility;
};

var getCalculations = function getCalculations(state) {
  return state.summary.calculations;
};

var getPending = function getPending(state) {
  return state.summary.pending;
};

var getHistory = function getHistory(state) {
  return state.history;
};

var getCalculationHistory = function getCalculationHistory(state) {
  return state.history.calculations;
};

var getPendingHistory = function getPendingHistory(state) {
  return state.history.pending;
};
var getTranches = function getTranches(state) {
  return state.tranches;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: getAll,
  getPending: getPending,
  getPayment: getPayment,
  getPaymentSaldo: getPaymentSaldo,
  getPayoutPossibility: getPayoutPossibility,
  getCalculations: getCalculations,
  getHistory: getHistory,
  getCalculationHistory: getCalculationHistory,
  getPendingHistory: getPendingHistory,
  getTranches: getTranches
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(135);




var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: {
    summary: {
      payments: {
        saldo: '',
        payout_possibility: false
      },
      calculations: {},
      pending: false
    },
    history: {
      pending: false
    }
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SAVE_SUMMARY: function SAVE_SUMMARY(state, data) {
    var summary = state.summary;
    summary.calculations = data.summary.calculations;
    summary.payments = data.summary.payments;
    summary.pending = false;
  },
  SAVE_SALDO: function SAVE_SALDO(state, data) {
    state.summary.payments = data.summary.payments;
  },
  PENDING: function PENDING(state, data) {
    state.summary.pending = data;
  },
  SAVE_HISTORY: function SAVE_HISTORY(state, data) {
    state.history = data.history;
    state.history.pending = false;
  },
  PENDING_HISTORY: function PENDING_HISTORY(state, data) {
    state.history.pending = data;
  },
  SAVE_TRANCHES: function SAVE_TRANCHES(state, data) {
    state.tranches = data;
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__ = __webpack_require__(39);




var pagination = ['total_pages', 'next_page', 'previous_page', 'total_pages', 'total_records', 'post_per_page'];
var trancheStructure = {
  id: true,
  amount: true,
  status: true,
  token: true,
  account: {
    email: true,
    id: true
  }
};

var getTranches = function getTranches(_ref) {
  var state = _ref.state,
      commit = _ref.commit;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  commit('PENDING', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        tranches: {
          where: {
            page: pageNumber
          },
          select: {
            page_data: trancheStructure,
            pagination: pagination
          }
        }
      })
    };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].get('/api/graphql', { params: query }).then(function (response) {
      commit('SAVE_TRANCHES', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING', false);
      reject(error.response.data);
    });
  });
};

var findTranchesBy = function findTranchesBy(_ref2, condition) {
  var state = _ref2.state,
      commit = _ref2.commit;

  commit('PENDING', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        tranches: {
          where: condition,
          select: {
            page_data: trancheStructure,
            pagination: pagination
          }
        }
      })
    };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].get('/api/graphql', { params: query }).then(function (response) {
      commit('SAVE_SEARCH_TRANCHES', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING', false);
      reject(error.response.data);
    });
  });
};

var getStatuses = function getStatuses(_ref3, condition) {
  var state = _ref3.state,
      commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        tranches: {
          statuses: ['name', 'value']
        }
      })
    };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].get('/api/graphql', { params: query }).then(function (response) {
      commit('SAVE_STATUSES', response.data);
      resolve(response);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

var changeTrancheStatus = function changeTrancheStatus(_ref4, query) {
  var state = _ref4.state,
      commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].post('/api/accountants/tranch_statuses', query).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error.response.data);
    });
  });
};

var getPromotorTranches = function getPromotorTranches(_ref5) {
  var state = _ref5.state,
      commit = _ref5.commit;

  commit('PENDING', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        account: {
          tranches: {
            amount: true,
            token: true,
            created_at: true,
            changes: ['status', 'updated_at']
          }
        }
      })
    };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].get('/api/graphql', { params: query }).then(function (response) {
      commit('SAVE_TRANCHES', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING', false);
      reject(error.response.data);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getTranches: getTranches,
  getPromotorTranches: getPromotorTranches,
  findTranchesBy: findTranchesBy,
  getStatuses: getStatuses,
  changeTrancheStatus: changeTrancheStatus
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getTranches = function getTranches(state) {
  return state.tranches;
};

var getStatuses = function getStatuses(state) {
  return state.statuses;
};

var getSearchTranches = function getSearchTranches(state) {
  return state.searchTranches;
};

var getTranchesPending = function getTranchesPending(state) {
  return state.pending;
};

var getPagination = function getPagination(state) {
  return state.tranchesPagination;
};

var getSearchPagination = function getSearchPagination(state) {
  return state.searchPagination;
};

var isSearchDataExist = function isSearchDataExist(state) {
  return state.searchDataExist;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getTranches: getTranches,
  getStatuses: getStatuses,
  getTranchesPending: getTranchesPending,
  getSearchTranches: getSearchTranches,
  getSearchPagination: getSearchPagination,
  getPagination: getPagination,
  isSearchDataExist: isSearchDataExist
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(139);




var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: {
    tranches: [],
    tranchesPagination: false,
    searchTranches: [],
    searchPagination: false,
    searchDataExist: null,
    pending: true,
    statuses: []
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SAVE_TRANCHES: function SAVE_TRANCHES(state, data) {
    if (data.account && data.account.tranches) {
      state.tranches = data.account.tranches;
    } else if (data.tranches) {
      state.tranches = data.tranches.page_data;
      state.tranchesPagination = data.tranches.pagination;
    }
    state.pending = false;
  },
  PENDING: function PENDING(state, data) {
    state.pending = data;
  },
  SAVE_SEARCH_TRANCHES: function SAVE_SEARCH_TRANCHES(state, data) {
    state.searchTranches = data.tranches.page_data;
    state.searchDataExist = data.tranches.page_data.length > 0;
    state.searchPagination = data.tranches.pagination;
    state.pending = false;
  },
  CLEAR_SEARCH: function CLEAR_SEARCH(state, data) {
    state.searchTranches = [];
    state.searchDataExist = null;
    state.searchPagination = false;
  },
  SAVE_STATUSES: function SAVE_STATUSES(state, data) {
    state.statuses = data.tranches.statuses;
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__ = __webpack_require__(39);




var pagination = ['total_pages', 'next_page', 'previous_page', 'total_records', 'post_per_page'];

var accountStructure = {
  id: true,
  confirmation_date: true,
  email: true,
  payments: {
    saldo: true
  },
  calculations: {
    started: true,
    completed: true,
    phone_confirmed: true,
    sold_policies: true
  }
};

var detailsUserStructure = {
  id: true,
  first_name: true,
  last_name: true,
  email: true,
  phone: true,
  website_url: true,
  website: true,
  social_media: true,
  marketing: true,
  email_marketing: true,
  payments_info: {
    account_type: true,
    company_name: true,
    nip: true,
    pesel: true,
    bank_account: true,
    street_name: true,
    street_number: true,
    city: true,
    zip_code: true
  },
  tranches_info: {
    token: true,
    amount: true,
    created_at: true
  },
  settlement: {
    cps: true,
    cpl: true
  }
};

var getList = function getList(_ref) {
  var state = _ref.state,
      commit = _ref.commit;
  var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  commit('PENDING', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        partners: {
          where: {
            page: pageNumber
          },
          select: {
            accounts: accountStructure,
            pagination: pagination
          }
        }
      })
    };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].get('/api/graphql', { params: query }).then(function (response) {
      commit('SAVE_LIST', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING', false);
      reject(error.response.data);
    });
  });
};

var findBy = function findBy(_ref2, condition) {
  var state = _ref2.state,
      commit = _ref2.commit;

  commit('PENDING', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        partners: {
          where: condition,
          select: {
            accounts: accountStructure,
            pagination: pagination
          }
        }
      })
    };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].get('/api/graphql', { params: query }).then(function (response) {
      commit('SAVE_SEARCH', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING', false);
      reject(error.response.data);
    });
  });
};

var findOne = function findOne(_ref3, condition) {
  var state = _ref3.state,
      commit = _ref3.commit;

  commit('PENDING', true);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var query = {
      query: __WEBPACK_IMPORTED_MODULE_2__services_queryBuilder__["a" /* default */].buildQuery({
        account: {
          where: condition,
          select: detailsUserStructure
        }
      })
    };

    __WEBPACK_IMPORTED_MODULE_1__services_http__["a" /* http */].get('/api/graphql', { params: query }).then(function (response) {
      commit('SAVE_SINGLE', response.data);
      resolve(response);
    }).catch(function (error) {
      commit('PENDING', false);
      reject(error.response.data);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList,
  findBy: findBy,
  findOne: findOne
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getList = function getList(state) {
  return state.accounts;
};
var getSearchData = function getSearchData(state) {
  return state.searchData;
};
var getListPending = function getListPending(state) {
  return state.pending;
};
var getAccountData = function getAccountData(state) {
  return state.accountData;
};
var getPagination = function getPagination(state) {
  return state.pagination;
};
var getSearchPagination = function getSearchPagination(state) {
  return state.searchPagination;
};
var isSearchDataExist = function isSearchDataExist(state) {
  return state.searchDataExist;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList,
  getListPending: getListPending,
  getSearchData: getSearchData,
  getAccountData: getAccountData,
  getSearchPagination: getSearchPagination,
  getPagination: getPagination,
  isSearchDataExist: isSearchDataExist
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(143);




var namespaced = true;

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: namespaced,
  state: {
    accounts: [],
    pagination: {},
    searchData: [],
    searchPagination: {},
    searchDataExist: null,
    pending: true,
    accountData: {}
  },
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SAVE_LIST: function SAVE_LIST(state, data) {
    if (data.partners && data.partners.accounts) {
      state.accounts = data.partners.accounts;
      state.pagination = data.partners.pagination;
    }
    state.pending = false;
  },
  PENDING: function PENDING(state, data) {
    state.pending = data;
  },
  SAVE_SEARCH: function SAVE_SEARCH(state, data) {
    state.searchData = data.partners.accounts;
    state.searchDataExist = data.partners.accounts.length > 0;
    state.searchPagination = data.partners.pagination;
    state.pending = false;
  },
  SAVE_SINGLE: function SAVE_SINGLE(state, data) {
    if (data.account) {
      state.accountData = data.account;
    }
    state.pending = false;
  },
  CLEAR_SEARCH: function CLEAR_SEARCH(state, data) {
    state.searchData = [];
    state.searchDataExist = null;
    state.searchPagination = {};
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_headerBar_headerBar__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_headerBar_headerBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_headerBar_headerBar__);

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_2__components_headerBar_headerBar___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['isLoggedIn']))
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_helper__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'name', 'label', 'imageUrl', 'utm_source', 'utm_medium', 'utm_brand', 'size', 'url', 'utm_campaign'],
  methods: {
    select: function select(e) {
      e.target.select();
      this.text = e.target.value;
      e.target.nextElementSibling.click();
    },
    copyUrl: function copyUrl(e) {
      var text = this.text || e.target.previousElementSibling.value;
      if (text && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_helper__["c" /* copyToClipboard */])(text)) {
        __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.toast('Skopiowano link banera', 2000);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.toast('Nie udało się skopiować linku', 1000);
      }
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_helper__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_banners_bannerUrl__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_banners_bannerUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_banners_bannerUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { BannerUrl: __WEBPACK_IMPORTED_MODULE_2__components_banners_bannerUrl___default.a },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getUserRoles', 'getMpcCode']), {
    isAgent: function isAgent() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_helper__["a" /* userHasRole */])(this.getUserRoles, 'agent');
    },
    isAnyAgent: function isAnyAgent() {
      var agentRoles = ['agent', 'agent_level2'];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_helper__["b" /* userHasAnyOfRoles */])(this.getUserRoles, agentRoles);
    }
  }),
  data: function data() {
    return {
      isAc: false,
      isTravel: false
    };
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_searcher__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_searcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_forms_searcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* createNamespacedHelpers */])('tranches'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a, FormSearcher: __WEBPACK_IMPORTED_MODULE_2__components_forms_searcher___default.a },
  data: function data() {
    return {
      search: '',
      loading: false,
      responseMessage: ''
    };
  },

  methods: {
    buttonSendEmail: function buttonSendEmail() {
      this.responseMessage = '';
      if (this.search) {
        this.sendEmail();
      } else {
        this.responseMessage = 'Najpierw wprowadź adres email beneficjenta.';
      }
    },
    sendEmail: function sendEmail() {
      var _this = this;

      this.toggleLoader();
      this.responseMessage = '';
      this.$store.dispatch('reminderBeneficiaryEmail', this.search).then(function (response) {
        if (response.code === 200) {
          _this.responseMessage = response.data.message;
          _this.toggleLoader();
          _this.clearSearch();
        }
      }, function (errorResponse) {
        _this.responseMessage = errorResponse.errors.message + '\nW razie powtarzających się problemów skontaktuj się z działem IT';
        _this.toggleLoader();
      });
    },
    toggleLoader: function toggleLoader() {
      this.loading = !this.loading;
    },
    clearSearch: function clearSearch() {
      this.search = '';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters([]))
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('promoCode', 'get');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getPromoUrl']))
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_searcher__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_forms_searcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_forms_searcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* createNamespacedHelpers */])('tranches'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a, FormSearcher: __WEBPACK_IMPORTED_MODULE_2__components_forms_searcher___default.a },
  data: function data() {
    return {
      search: '',
      loading: false,
      responseMessage: ''
    };
  },

  methods: {
    buttonProcessLead: function buttonProcessLead() {
      this.responseMessage = '';
      if (this.search) {
        this.processLead();
      } else {
        this.responseMessage = 'Najpierw wprowadź SALESFORCE ID';
      }
    },
    processLead: function processLead() {
      var _this = this;

      this.showLoader();
      this.responseMessage = '';
      this.$store.dispatch('processLead', this.search).then(function (response) {
        if (response.code === 200) {
          _this.responseMessage = response.data.message;
          _this.hideLoader();
          _this.clearSearch();
        }
      }, function (errorResponse) {
        _this.responseMessage = errorResponse.errors.message + '\nW razie powtarzających się problemów skontaktuj się z działem IT';
        _this.hideLoader();
      });
    },
    showLoader: function showLoader() {
      this.loading = true;
    },
    hideLoader: function hideLoader() {
      this.loading = false;
    },
    clearSearch: function clearSearch() {
      this.search = '';
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters([]))
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['errors']
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['label', 'value', 'dataTooltip', 'buttonIcon'],
  methods: {
    searcher: function searcher() {
      this.$emit('submitAction');
    },
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    }
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_moneyInfo__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_moneyInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_moneyInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_helper__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_6__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_4__components_findUs___default.a, Contact: __WEBPACK_IMPORTED_MODULE_5__components_contact___default.a, MoneyInfo: __WEBPACK_IMPORTED_MODULE_3__components_moneyInfo___default.a },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])(['logout']), {
    destroyNav: function destroyNav() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.menu-right .button-collapse').sideNav('destroy');
    },
    updateNav: function updateNav() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.menu-right .button-collapse').sideNav({
        edge: 'right',
        closeOnClick: true,
        draggable: true,
        onOpen: function onOpen(el) {
          el.addClass('open');
        },
        onClose: function onClose(el) {
          el.removeClass('open');
        }
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapGetters */])(['isLoggedIn', 'getUserRoles']), {
    navLinks: function navLinks() {
      var navLinks = [];
      switch (true) {
        case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_helper__["a" /* userHasRole */])(this.getUserRoles, 'agent'):
          navLinks = [{ name: 'NARZĘDZIA', routerName: 'tools' }];
          break;
        case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_helper__["a" /* userHasRole */])(this.getUserRoles, 'admin'):
          navLinks = [{ name: 'STATYSTYKI PARTNERÓW', routerName: 'users' }];
        // falls through
        case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_helper__["a" /* userHasRole */])(this.getUserRoles, 'accountant'):
          navLinks = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(navLinks), [{ name: 'TRANSZE', routerName: 'tranches' }, { name: 'MAILE', routerName: 'mails' }, { name: 'PEŁNY PROCES', routerName: 'completeProcess' }]);
          break;
        case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_helper__["a" /* userHasRole */])(this.getUserRoles, 'agent_level2'):
          navLinks = [{ name: 'NARZĘDZIA', routerName: 'tools' }];
          break;
        default:
          navLinks = [{ name: 'NARZĘDZIA', routerName: 'tools' }, { name: 'TWOJE ŚRODKI', routerName: 'yourFunds' }];
      }
      return navLinks;
    },
    showSpecialToolsLink: function showSpecialToolsLink() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_helper__["b" /* userHasAnyOfRoles */])(this.getUserRoles, ['agent', 'agent_level2'])) {
        return false;
      }

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__services_helper__["b" /* userHasAnyOfRoles */])(this.getUserRoles, ['accountant', 'admin']);
    }
  }),
  updated: function updated() {
    this.destroyNav();
    if (this.isLoggedIn) {
      this.updateNav();
    }
  },
  mounted: function mounted() {
    this.destroyNav();
    if (this.isLoggedIn) {
      this.updateNav();
    }
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_helper__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'name', 'label', 'value'],
  methods: {
    select: function select(e) {
      e.target.select();
    },
    copyPromoUrl: function copyPromoUrl() {
      var value = this.value;
      if (value && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_helper__["c" /* copyToClipboard */])(value)) {
        __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.toast('Skopiowano: ' + value, 2000);
      } else {
        __WEBPACK_IMPORTED_MODULE_0_materialize_css___default.a.toast('Nie udało się skopiować linku', 1000);
      }
    }
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_helper__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['type', 'name', 'label'],
  created: function created() {
    this.$store.dispatch('promoCode', 'get');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getPromoUrl'])),
  methods: {
    select: function select(e) {
      e.target.select();
    },
    copyPromoUrl: function copyPromoUrl() {
      var text = this.getPromoUrl;
      if (text && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_helper__["c" /* copyToClipboard */])(text)) {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast('Skopiowano: ' + text, 2000);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast('Nie udało się skopiować linku', 1000);
      }
    }
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_helper__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['name'],
  beforeCreate: function beforeCreate() {
    if (typeof window.mFindWidget === 'undefined') {
      var scriptTag = document.createElement('script');
      scriptTag.src = "//cdn.mfind.pl/scripts/autka-widget.js";
      document.head.appendChild(scriptTag);
    }
  },
  created: function created() {
    this.$store.dispatch('promoCode', 'get');
  },
  mounted: function mounted() {
    this.asyncLoadAutkaWidget(function () {
      var widgetContainer = document.getElementsByClassName('mfind-widget')[0];

      if (typeof widgetContainer !== 'undefined') {
        window.mFindWidget.initialize(widgetContainer, {
          utmSource: widgetContainer.dataset.utmSource,
          utmMedium: widgetContainer.dataset.utmMedium,
          mpc: widgetContainer.dataset.mpc,
          brand: 'punkta'
        });
      }
    });
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['getPromoWidget'])),
  methods: {
    select: function select(e) {
      e.target.select();
    },
    copyPromoWidget: function copyPromoWidget() {
      var text = this.getPromoWidget;
      if (text && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_helper__["c" /* copyToClipboard */])(text)) {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast('Skopiowano kod widgetu', 2000);
      } else {
        __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast('Nie udało się skopiować widgetu', 1000);
      }
    },
    asyncLoadAutkaWidget: function asyncLoadAutkaWidget(callback) {
      var _this = this;

      this.timeoutHolder = setTimeout(function () {
        clearTimeout(_this.timeoutHolder);
        if (typeof window.mFindWidget !== 'undefined') {
          return callback();
        } else {
          _this.asyncLoadAutkaWidget(callback);
        }
      }, 200); // 200ms
    }
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_errorMessage__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_forms_errorMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_forms_errorMessage__);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { ErrorMessage: __WEBPACK_IMPORTED_MODULE_0__components_forms_errorMessage___default.a },
  props: ['type', 'name', 'label', 'value', 'errors', 'required', 'pattern'],
  methods: {
    change: function change(e) {
      this.$emit('input', e.target.value);
      this.$emit('updateError');
    }
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({ props: ['token'] });

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modalTranche__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modalTranche___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modalTranche__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_searcher__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_searcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_forms_searcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* createNamespacedHelpers */])('tranches'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a, ModalTranche: __WEBPACK_IMPORTED_MODULE_3__components_modalTranche___default.a, FormSearcher: __WEBPACK_IMPORTED_MODULE_4__components_forms_searcher___default.a },
  data: function data() {
    return {
      search: '',
      currentPage: 1,
      items: false,
      tranche: false,
      showModal: false
    };
  },

  methods: {
    searchTranch: function searchTranch() {
      this.$store.dispatch('tranches/findTranchesBy', { token: '"' + this.search + '"' });
      this.currentPage = 1;
    },
    clearSearch: function clearSearch() {
      this.$store.commit('tranches/CLEAR_SEARCH');
      this.search = '';
      this.firstPage();
    },
    setPage: function setPage(pageNumber) {
      var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reload && (pageNumber === this.currentPage || pageNumber === null)) {
        return;
      }

      if (!this.getSearchTranches.length) {
        this.$store.dispatch('tranches/getTranches', pageNumber);
      } else {
        this.$store.dispatch('tranches/findTranchesBy', { token: '"' + this.search + '"', page: pageNumber });
      }
      this.currentPage = pageNumber;
    },
    previousPage: function previousPage() {
      this.setPage(this.selectPagination.previous_page);
    },
    nextPage: function nextPage() {
      this.setPage(this.selectPagination.next_page);
    },
    firstPage: function firstPage() {
      this.setPage(1);
    },
    lastPage: function lastPage() {
      this.setPage(this.selectPagination.total_pages);
    },
    buttonHide: function buttonHide(pageNumber) {
      return [this.currentPage === pageNumber ? 'btn-hide' : 'btn-show'];
    },
    buttonClose: function buttonClose() {
      return [this.search.length ? 'btn-show' : 'btn-hide'];
    },
    currentStatusVal: function currentStatusVal(status) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.getStatuses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (item.name === status) {
            return item.value;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    openModal: function openModal(tranche) {
      this.showModal = true;
      this.tranche = tranche;
      this.trancheStatus = this.currentStatusVal(tranche.status);
    },
    reloadTranches: function reloadTranches() {
      this.setPage(this.currentPage, true);
    }
  },
  created: function created() {
    this.$store.dispatch('tranches/getTranches');
    this.$store.dispatch('tranches/getStatuses');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getTranches', 'getStatuses', 'getTranchesPending', 'getSearchTranches', 'getPagination', 'getSearchPagination', 'isSearchDataExist']), {
    rows: function rows() {
      return this.getSearchTranches.length ? this.getSearchTranches : this.getTranches;
    },
    selectPagination: function selectPagination() {
      return this.getSearchTranches.length ? this.getSearchPagination : this.getPagination;
    }
  })
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modalUser__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modalUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modalUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_searcher__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_searcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_forms_searcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* createNamespacedHelpers */])('users'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a, ModalUser: __WEBPACK_IMPORTED_MODULE_2__components_modalUser___default.a, FormSearcher: __WEBPACK_IMPORTED_MODULE_3__components_forms_searcher___default.a },
  data: function data() {
    return {
      search: '',
      currentPage: 1,
      items: false,
      accounts: false,
      showModal: false
    };
  },

  methods: {
    searchUser: function searchUser() {
      this.$store.dispatch('users/findBy', { email: '"' + this.search + '"' });
      this.currentPage = 1;
    },
    clearSearch: function clearSearch() {
      this.$store.commit('users/CLEAR_SEARCH');
      this.search = '';
      this.firstPage();
    },
    setPage: function setPage(pageNumber) {
      var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reload && (pageNumber === this.currentPage || pageNumber === null)) return;

      if (!this.getSearchData.length) {
        this.$store.dispatch('users/getList', pageNumber);
      } else {
        this.$store.dispatch('users/findBy', { email: '"' + this.search + '"', page: pageNumber });
      }
      this.currentPage = pageNumber;
    },
    previousPage: function previousPage() {
      this.setPage(this.selectPagination.previous_page);
    },
    nextPage: function nextPage() {
      this.setPage(this.selectPagination.next_page);
    },
    firstPage: function firstPage() {
      this.setPage(1);
    },
    lastPage: function lastPage() {
      this.setPage(this.selectPagination.total_pages);
    },
    buttonHide: function buttonHide(pageNumber) {
      return [this.currentPage === pageNumber ? 'btn-hide' : 'btn-show'];
    },
    buttonClose: function buttonClose() {
      return [this.search.length ? 'btn-show' : 'btn-hide'];
    },
    openModal: function openModal(account) {
      this.showModal = true;
      this.$store.dispatch('users/findOne', { id: account.id });
    }
  },
  created: function created() {
    this.$store.dispatch('users/getList');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getList', 'getListPending', 'getSearchData', 'getPagination', 'getSearchPagination', 'isSearchDataExist', 'getAccountData']), {
    rows: function rows() {
      return this.getSearchData.length ? this.getSearchData : this.getList;
    },
    account: function account() {
      return this.getAccountData;
    },
    selectPagination: function selectPagination() {
      return this.getSearchData.length ? this.getSearchPagination : this.getPagination;
    }
  })
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    loading: Boolean,
    type: { type: String, default: 'big' }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, exports) {

//
//
//
//
//
//

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['showModal'],
  methods: {
    close: function close() {
      this.$emit('close');
    }
  },
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('keydown', function (e) {
      if (_this.showModal && e.keyCode === 27) {
        _this.close();
      }
    });
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_statsIndicator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_statsIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_statsIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoiceDetails__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_invoiceDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_invoiceDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['saldo', 'showModal'],
  components: { StatsIndicator: __WEBPACK_IMPORTED_MODULE_0__components_statsIndicator___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a, Modal: __WEBPACK_IMPORTED_MODULE_3__components_modal___default.a, InvoiceDetails: __WEBPACK_IMPORTED_MODULE_1__components_invoiceDetails___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        tranche: {
          token: false,
          amount: false
        },
        errors: false
      }
    };
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    trancheAmount: function trancheAmount() {
      return this.data.tranche.amount ? this.data.tranche.amount : this.saldo;
    },
    payout: function payout() {
      var _this = this;

      this.data.errors = false;
      this.data.loading = true;
      this.$store.dispatch('generateTranche').then(function (response) {
        if (response.code === 200) {
          _this.data.tranche.amount = response.data.invoice_amount;
          _this.data.tranche.token = response.data.invoice_token;
          _this.data.loading = false;
        }
      }, function (errorResponse) {
        _this.data.errors = errorResponse.errors;
        _this.data.loading = false;
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    document.addEventListener('keydown', function (e) {
      if (_this2.showModal && e.keyCode === 27) {
        _this2.close();
      }
    });
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tranche', 'showModal'],
  components: { Loader: __WEBPACK_IMPORTED_MODULE_0__components_loader___default.a, Modal: __WEBPACK_IMPORTED_MODULE_1__components_modal___default.a },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_materialize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_materialize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* createNamespacedHelpers */])('tranches'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tranche', 'showModal', 'currentStatus'],
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a, Modal: __WEBPACK_IMPORTED_MODULE_3__components_modal___default.a },
  data: function data() {
    return {
      status: '' + this.currentStatus,
      data: {
        loading: false,
        errors: false
      }
    };
  },

  methods: {
    close: function close() {
      this.$emit('close');
    },
    changeStatus: function changeStatus() {
      var _this = this;

      this.data.errors = false;
      this.data.loading = true;
      this.$store.dispatch('tranches/changeTrancheStatus', {
        'tranch_id': this.tranche.id,
        'status': this.status
      }).then(function (response) {
        if (response.code === 200) {
          _this.data.loading = false;
          __WEBPACK_IMPORTED_MODULE_1_materialize_css___default.a.toast(response.data.message, 4000);
          _this.$emit('reloadTranches');
          _this.close();
        }
      }, function (errorResponse) {
        _this.data.errors = errorResponse.errors;
        _this.data.loading = false;
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getStatuses']))
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_invoiceDetails__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_invoiceDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_invoiceDetails__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_statsIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['tranche', 'showModal'],
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a, Modal: __WEBPACK_IMPORTED_MODULE_3__components_modal___default.a, StatsIndicator: __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator___default.a, InvoiceDetails: __WEBPACK_IMPORTED_MODULE_0__components_invoiceDetails___default.a },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* createNamespacedHelpers */])('users'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['account', 'showModal'],
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a, Modal: __WEBPACK_IMPORTED_MODULE_2__components_modal___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        errors: false
      }
    };
  },

  methods: {
    close: function close() {
      this.$emit('close');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters([
    // 'getStatuses'
  ]))
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//



var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* createNamespacedHelpers */])('statistics'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    this.$store.dispatch('statistics/getPaymentSaldo', 'get');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getPaymentSaldo']))
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modalTrancheHistory__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modalTrancheHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_modalTrancheHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* createNamespacedHelpers */])('tranches'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a, ModalTrancheHistory: __WEBPACK_IMPORTED_MODULE_2__components_modalTrancheHistory___default.a },
  data: function data() {
    return {
      tranche: false,
      showModal: false
    };
  },

  methods: {
    openModal: function openModal(tranche) {
      this.showModal = true;
      this.tranche = tranche;
    }
  },
  created: function created() {
    this.$store.dispatch('tranches/getPromotorTranches');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getTranches', 'getTranchesPending']))
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_statsIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: { StatsIndicator: __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  methods: {
    showProvisionFor: function showProvisionFor(settlementType) {
      return this.getUserSettlementType(settlementType);
    },
    showSettlementTypeClass: function showSettlementTypeClass() {
      return this.getUserSettlementType();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getUserPending', 'getUserSettlementType']))
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* createNamespacedHelpers */])('statistics'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a },
  props: ['chartType'],
  data: function data() {
    return {
      activeSet: 'all',
      statSets: {
        all: {
          name: 'Wszystkie kalkulacje',
          rows: ['date', 'started', 'completed'],
          columns: [{
            'type': 'date',
            'label': 'Data'
          }, {
            'type': 'number',
            'label': 'Rozpoczęte kalkulacje'
          }, {
            'type': 'number',
            'label': 'Zakończone kalkulacje'
          }]
        },
        started: {
          name: 'Rozpoczęte kalkulacje',
          rows: ['date', 'started'],
          columns: [{
            'type': 'date',
            'label': 'Date'
          }, {
            'type': 'number',
            'label': 'Rozpoczęte kalkulacje'
          }]
        },
        completed: {
          name: 'Zakończone kalkulacje',
          rows: ['date', 'completed'],
          columns: [{
            'type': 'date',
            'label': 'Date'
          }, {
            'type': 'number',
            'label': 'Zakończone kalkulacje'
          }]
        }
      },
      options: {
        title: '',
        hAxis: { title: '' },
        vAxis: { title: '', viewWindow: { min: 0 }, gridlines: { count: 4 } },
        legend: 'none',
        curveType: 'function',
        pointSize: 3,
        animation: { duration: 500, easing: 'out' }
      }
    };
  },
  created: function created() {
    this.$store.dispatch('statistics/getCalculationHistory', 'get');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getPendingHistory', 'getCalculationHistory']), {
    rows: function rows() {
      var statKeys = this.statSets[this.activeSet].rows;
      var rows = [];
      var data = this.getCalculationHistory;

      var _loop = function _loop(i) {
        var item = [];
        statKeys.map(function (key) {
          item.push(key === 'date' ? new Date(data[i][key]) : data[i][key]);
        });
        rows.push(item);
      };

      for (var i in data) {
        _loop(i);
      }
      return rows;
    },
    columns: function columns() {
      return this.statSets[this.activeSet].columns;
    }
  })
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_statsIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* createNamespacedHelpers */])('statistics'),
    mapGetters = _createNamespacedHelp.mapGetters;

/* harmony default export */ __webpack_exports__["default"] = ({
  components: { StatsIndicator: __WEBPACK_IMPORTED_MODULE_1__components_statsIndicator___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  created: function created() {
    this.$store.dispatch('statistics/getAll', 'get');
  },

  methods: {
    showStatsFor: function showStatsFor(settlementType) {
      return this.getUserSettlementType(settlementType);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getAll', 'getPending', 'getPayment', 'getCalculations']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['getUserSettlementType']))
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['stats', 'unit', 'icon'],
  methods: {}
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_promoUrl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_promoUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_inputs_promoUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_helper__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_md5__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: { InputPromoUrl: __WEBPACK_IMPORTED_MODULE_1__components_inputs_promoUrl___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  created: function created() {
    if (this.isLoggedIn) {
      this.$store.dispatch('getUser');
    }
  },

  methods: {
    showForRole: function showForRole(role) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__services_helper__["a" /* userHasRole */])(this.getUserRoles, role);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['getUser', 'getUserPending', 'isLoggedIn', 'getUserRoles']), {
    avatarUrl: function avatarUrl() {
      var hash = '';
      if (this.getUser && this.getUser.email) hash = __WEBPACK_IMPORTED_MODULE_4_md5___default()(this.getUser.email);
      return 'https://www.gravatar.com/avatar/' + hash + '?s=100&d=mm';
    }
  })
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'passReset',
  components: { NoAuthLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default.a },
  beforeCreate: function beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push({ name: 'dashboard' });
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'confirmEmail',
  components: { NoAuthLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default.a, Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        success: false,
        message: '',
        errors: false
      }
    };
  },

  methods: {
    auth: function auth() {
      var _this = this;

      this.$store.dispatch('auth').then(function (response) {
        return _this.$router.push({ name: 'accountDetails' });
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.data.loading = true;
    this.$store.dispatch('confirmEmail', {
      confirmation_token: this.$route.query.confirmation_token
    }).then(function (response) {
      _this2.data.loading = false;
      if (response.code === 200) {
        _this2.data.success = true;
        _this2.data.message = response.data.message;
      }
    }, function (errorResponse) {
      _this2.data.loading = false;
      _this2.data.errors = errorResponse.errors;
    });
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contact__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accountDetailsForm_index__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_accountDetailsForm_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_accountDetailsForm_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modalSuccessAccountDetails__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modalSuccessAccountDetails___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_modalSuccessAccountDetails__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_2__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_0__components_findUs___default.a, Contact: __WEBPACK_IMPORTED_MODULE_1__components_contact___default.a, AccountDetailsForm: __WEBPACK_IMPORTED_MODULE_3__components_accountDetailsForm_index___default.a, ModalSuccessAccountDetails: __WEBPACK_IMPORTED_MODULE_4__components_modalSuccessAccountDetails___default.a },
  name: 'AccountDetails',
  data: function data() {
    return {
      showModal: false
    };
  },

  methods: {
    showSuccessModal: function showSuccessModal() {
      this.showModal = !this.showModal;
    },
    closeSuccessModal: function closeSuccessModal() {
      this.$router.push({ name: 'dashboard' });
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_helper__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_loader__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: { Loader: __WEBPACK_IMPORTED_MODULE_1__components_loader___default.a },
  created: function created() {
    var _this = this;

    this.$store.dispatch('getUser').then(function (response) {
      if (response.code === 200) {
        switch (true) {
          case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_helper__["a" /* userHasRole */])(response.data.user.roles, 'admin'):
            _this.$router.push({ name: 'users' });
            break;
          case __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_helper__["a" /* userHasRole */])(response.data.user.roles, 'accountant'):
            _this.$router.push({ name: 'tranches' });
            break;
          default:
            _this.$router.push({ name: 'tools' });
        }
      }
    });
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_beneficiaryMailReminder__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_beneficiaryMailReminder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_beneficiaryMailReminder__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Mails',
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_0__components_findUs___default.a, BeneficiaryMailReminder: __WEBPACK_IMPORTED_MODULE_2__components_beneficiaryMailReminder___default.a }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_completeProcess__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_completeProcess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_completeProcess__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProcessLead',
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_0__components_findUs___default.a, CompleteProcess: __WEBPACK_IMPORTED_MODULE_2__components_completeProcess___default.a }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listTranches__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listTranches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_listTranches__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Tranches',
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_0__components_findUs___default.a, ListTranches: __WEBPACK_IMPORTED_MODULE_2__components_listTranches___default.a }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contact__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_manual_manual__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_manual_manual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_manual_manual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_helper__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_inputs_promoUrl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_inputs_promoUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_inputs_promoUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_banners_banners__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_banners_banners___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_banners_banners__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_inputs_copyUrl__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_inputs_copyUrl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_inputs_copyUrl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_inputs_promoWidget__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_inputs_promoWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_inputs_promoWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_calculateButton_vue__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_calculateButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_calculateButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_4__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_1__components_findUs___default.a, Banners: __WEBPACK_IMPORTED_MODULE_7__components_banners_banners___default.a, InputPromoUrl: __WEBPACK_IMPORTED_MODULE_6__components_inputs_promoUrl___default.a, InputCopyUrl: __WEBPACK_IMPORTED_MODULE_8__components_inputs_copyUrl___default.a, TextareaPromoWidget: __WEBPACK_IMPORTED_MODULE_9__components_inputs_promoWidget___default.a, Manual: __WEBPACK_IMPORTED_MODULE_3__components_manual_manual___default.a, Contact: __WEBPACK_IMPORTED_MODULE_2__components_contact___default.a, CalculateButton: __WEBPACK_IMPORTED_MODULE_10__components_calculateButton_vue___default.a },
  name: 'UserInvite',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapGetters */])(['getUserRoles', 'getMpcCode']), {
    isAgent: function isAgent() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_helper__["a" /* userHasRole */])(this.getUserRoles, 'agent');
    },
    isAnyAgent: function isAnyAgent() {
      var agentRoles = ['agent', 'agent_level2'];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__services_helper__["b" /* userHasAnyOfRoles */])(this.getUserRoles, agentRoles);
    }
  }),
  beforeMount: function beforeMount() {
    this.$store.dispatch('promoCode', 'get');
  },
  data: function data() {
    var root = window.location.origin;
    return {
      child_agent_registration_url: root + '/rejestracja-agenta?parent_mpc_code='
    };
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listUsers__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_listUsers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_listUsers__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Users',
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_1__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_0__components_findUs___default.a, ListUsers: __WEBPACK_IMPORTED_MODULE_2__components_listUsers___default.a }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_findUs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_findUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_findUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contact__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_userInfo__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_userInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_userInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_statsGrid__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_statsGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_statsGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_provisionTable__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_provisionTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_provisionTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_statsChart__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_statsChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_statsChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_promotorTranches__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_promotorTranches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_promotorTranches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modalPayout__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modalPayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_modalPayout__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _createNamespacedHelp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* createNamespacedHelpers */])('statistics'),
    mapGetters = _createNamespacedHelp.mapGetters;









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { UserInfo: __WEBPACK_IMPORTED_MODULE_4__components_userInfo___default.a, FindUs: __WEBPACK_IMPORTED_MODULE_2__components_findUs___default.a, StatsGrid: __WEBPACK_IMPORTED_MODULE_5__components_statsGrid___default.a, ProvisionTable: __WEBPACK_IMPORTED_MODULE_6__components_provisionTable___default.a, StatsChart: __WEBPACK_IMPORTED_MODULE_7__components_statsChart___default.a, PromotorTranches: __WEBPACK_IMPORTED_MODULE_8__components_promotorTranches___default.a, ModalPayout: __WEBPACK_IMPORTED_MODULE_9__components_modalPayout___default.a, Contact: __WEBPACK_IMPORTED_MODULE_3__components_contact___default.a },
  name: 'YourFounds',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGetters(['getPayoutPossibility', 'getPaymentSaldo'])),
  data: function data() {
    return {
      showModal: false
    };
  },

  methods: {
    toggleModal: function toggleModal() {
      this.showModal = !this.showModal;
    },
    isPaymentReady: function isPaymentReady() {
      if (this.getPayoutPossibility) {
        this.toggleModal();
      }
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  beforeCreate: function beforeCreate() {
    this.$router.push({ name: 'login' });
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_inputs_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'login',
  components: { NoAuthLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default.a, InputField: __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        email: '',
        password: '',
        errors: false
      }
    };
  },
  beforeCreate: function beforeCreate() {
    var _this = this;

    if (!this.$store.getters.isLoggedIn) return;

    if (this.$route.query.return_to_opener !== 'true') {
      this.$router.push({ name: 'dashboard' });
      return;
    }

    var fetchUserEmail = function fetchUserEmail() {
      return _this.$store.dispatch('getUser').then(function (response) {
        if (response.code === 200) {
          return response.data.user.email;
        }
      });
    };
    var fetchUserMpcCode = function fetchUserMpcCode() {
      return _this.$store.dispatch('promoCode').then(function (response) {
        if (response.code === 200) {
          return response.data.mpc_code;
        }
      });
    };
    fetchUserEmail().then(function (email) {
      return fetchUserMpcCode().then(function (mpc) {
        _this.$store.dispatch('confirmAuthorizationInB2c', { email: email, mpcCode: mpc });
      });
    });
  },

  methods: {
    authorize: function authorize(provider) {
      var _this2 = this;

      this.data.loading = true;
      this.$store.dispatch('authSocial', { provider: provider }).then(function (response) {
        _this2.data.loading = false;
        _this2.$router.push({ name: 'dashboard' });
      }, function (errorResponse) {
        _this2.data.loading = false;
      });
    },
    submitLogin: function submitLogin() {
      var _this3 = this;

      this.data.loading = true;
      this.$store.dispatch('login', {
        email: this.data.email,
        password: this.data.password
      }).then(function (response) {
        _this3.data.loading = false;
        if (response.code === 200) {
          if (response.returnToOpener) {
            return _this3.$store.dispatch('confirmAuthorizationInB2c', { email: _this3.data.email, mpcCode: response.mpcCode });
          }
          _this3.$router.push({ name: 'dashboard' });
        }
      }, function (errorResponse) {
        _this3.data.loading = false;
        _this3.data.errors = errorResponse.errors;
      });
    }
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'logoutAgent',
  beforeCreate: function beforeCreate() {
    this.$store.dispatch('logout');
    window.close();
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_inputs_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'passForgot',
  components: { NoAuthLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default.a, InputField: __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        email: '',
        success: false,
        errors: false
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
      // redirect to auth change password
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.data.loading = true;
      this.$store.dispatch('passForgot', {
        user: { email: this.data.email }
      }).then(function (response) {
        _this.data.loading = false;
        if (response.code === 200) {
          _this.data.success = true;
        }
      }, function (errorResponse) {
        _this.data.loading = false;
        _this.data.errors = errorResponse.errors;
      });
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_inputs_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'passReset',
  components: { NoAuthLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default.a, InputField: __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        password: '',
        password_confirmation: '',
        errors: false
      }
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.data.loading = true;
      this.$store.dispatch('passReset', {
        user: {
          reset_password_token: this.$route.query.reset_password_token,
          password: this.data.password,
          password_confirmation: this.data.password_confirmation
        }
      }).then(function (response) {
        _this.data.loading = false;
        if (response.code === 200) {
          _this.$router.push({ name: 'login' });
        }
      }, function (errorResponse) {
        _this.data.loading = false;
        _this.data.errors = errorResponse.errors;
      });
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_inputs_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register',
  components: { NoAuthLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default.a, InputField: __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        errors: false
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push({ name: 'dashboard' });
    }
  },

  methods: {
    authorize: function authorize(provider) {
      var _this = this;

      this.data.loading = true;
      this.$store.dispatch('authSocial', { provider: provider }).then(function (response) {
        _this.data.loading = false;
        _this.$router.push({ name: 'dashboard' });
      }, function (errorResponse) {
        _this.data.loading = false;
      });
    },
    submitRegister: function submitRegister() {
      var _this2 = this;

      this.data.loading = true;
      this.$store.dispatch('register', {
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        email: this.data.email,
        password: this.data.password,
        password_confirmation: this.data.password_confirmation
      }).then(function (response) {
        if (response.code === 200) {
          _this2.data.loading = false;
          _this2.$router.push({ name: 'checkInbox' });
        }
      }, function (errorResponse) {
        _this2.data.loading = false;
        _this2.data.errors = errorResponse.errors;
      });
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_inputs_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register',
  components: { NoAuthLayout: __WEBPACK_IMPORTED_MODULE_0__layouts_noAuthLayout___default.a, InputField: __WEBPACK_IMPORTED_MODULE_1__components_inputs_text___default.a, Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a },
  data: function data() {
    return {
      data: {
        loading: false,
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        errors: false,
        parent_mpc_code: this.$route.query.parent_mpc_code
      }
    };
  },
  beforeCreate: function beforeCreate() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push({ name: 'dashboard' });
    }
  },

  methods: {
    authorize: function authorize(provider) {
      var _this = this;

      this.data.loading = true;
      this.$store.dispatch('authSocial', { provider: provider, isBroker: true, parentMpcCode: this.$route.query.parent_mpc_code }).then(function (response) {
        _this.data.loading = false;
        _this.$router.push({ name: 'dashboard' });
      }, function (errorResponse) {
        _this.data.loading = false;
      });
    },
    submitRegister: function submitRegister() {
      var _this2 = this;

      this.data.loading = true;
      this.$store.dispatch('register', {
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        email: this.data.email,
        password: this.data.password,
        password_confirmation: this.data.password_confirmation,
        punkta_agent: true,
        parent_mpc_code: this.data.parent_mpc_code
      }).then(function (response) {
        _this2.data.loading = false;
        if (response.code === 200) {
          _this2.$router.push({ name: 'checkInbox' });
        }
      }, function (errorResponse) {
        _this2.data.loading = false;
        _this2.data.errors = errorResponse.errors;
      });
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_inputs_text__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_inputs_text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_inputs_text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_errorMessage__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_forms_errorMessage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_forms_errorMessage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: { Loader: __WEBPACK_IMPORTED_MODULE_2__components_loader___default.a, InputField: __WEBPACK_IMPORTED_MODULE_3__components_inputs_text___default.a, ErrorMessage: __WEBPACK_IMPORTED_MODULE_4__components_forms_errorMessage___default.a },
  data: function data() {
    return {
      data: {
        formType: 'person',
        promotion_scope: {
          website: false,
          website_url: '',
          social_media: false,
          marketing: false,
          email_marketing: false
        },
        agreements: {
          data_truth_regulation: {
            checked: false,
            text: 'Oświadczam, że dane zawarte w formularzu są zgodne z prawdą.'
          },
          online_agreement: {
            checked: false,
            text: 'Wyra\u017Cam zgod\u0119 na zawarcie umowy w formie elektronicznej oraz akceptuj\u0119 postanowienia\n                   <a href="https://punkta.pl/regulaminy/#regulamin-programu-partnerskiego-punkta-autoopen" target="_blank" class="rules">\n                   Regulaminu Programu partnerskiego punkta.pl</a>'
          },
          data_processing: {
            checked: false,
            text: 'Wyra\u017Cam zgod\u0119 na przetwarzanie moich danych osobowych zgodnie z\n                   <a href="https://punkta.pl/regulaminy/#polityka-prywatnosci-autoopen" target="_blank">\n                   Polityk\u0105 prywatno\u015Bci</a>.'
          }
        },
        loading: false,
        errors: false
      }
    };
  },
  created: function created() {
    this.data.first_name = this.getUser.first_name;
    this.data.last_name = this.getUser.last_name;
  },

  methods: {
    getError: function getError(key, container) {
      if (!this.data.errors) return null;
      var errors = this.data.errors;
      if (container) {
        if (!errors[container]) return null;
        errors = errors[container];
      }
      return errors[key] && errors[key].checked ? errors[key].checked : errors[key];
    },
    submitForm: function submitForm() {
      var _this = this;

      var form = this.data;
      var payload = {
        agreements: form.agreements,
        account_type: form.formType,
        contact_phone: form.phone,
        promotion_scope: form.promotion_scope
      };

      if (form.formType === 'company') {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(payload, { company_name: form.company_name, nip: form.nip });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(payload, { first_name: form.first_name, last_name: form.last_name, pesel: form.pesel });
      }

      this.data.loading = true;
      this.$store.dispatch('sendAccountDetails', payload).then(function (response) {
        _this.data.errors = false;
        _this.data.loading = false;
        if (response.code === 200) {
          _this.$emit('sendSuccess');
          _this.$store.dispatch('getUser', { forceUpdate: true });
        }
      }, function (errorResponse) {
        _this.data.loading = false;
        _this.data.errors = errorResponse.errors;
      });
    },
    checkAllAgreements: function checkAllAgreements() {
      if (this.data.check_all_agreements) {
        var agreements = this.data.agreements;
        agreements.data_truth_regulation.checked = true;
        agreements.online_agreement.checked = true;
        agreements.data_processing.checked = true;

        if (this.data.errors && this.data.errors.agreements) {
          this.data.errors.agreements = null;
        }
      }
    },
    triggerSingleAgreement: function triggerSingleAgreement(modelName) {
      var agreements = this.data.agreements;
      if (this.data.errors && this.data.errors.agreements && agreements[modelName].checked) {
        this.data.errors.agreements[modelName] = null;
      }
      if (agreements.data_truth_regulation.checked && agreements.online_agreement.checked && agreements.data_processing.checked) {
        this.data.check_all_agreements = true;
      } else {
        this.data.check_all_agreements = false;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['getUser']))
});

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOS4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9Ii0yODUgNDA4LjkgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgLTI4NSA0MDguOSAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6IzFFMzk0QztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQ0KCS5zdDF7ZmlsbDpub25lO30NCgkuc3Qye2ZpbGw6bm9uZTtzdHJva2U6I0ZEQ0Q0MDt9DQo8L3N0eWxlPg0KPGcgaWQ9Ik91dGxpbmVfSWNvbnMiPg0KCTxnPg0KCQk8cG9seWxpbmUgY2xhc3M9InN0MiIgcG9pbnRzPSItMjY3LjUsNDI5LjQgLTI2Ny41LDQzMi40IC0yODEuNSw0MzIuNCAtMjgxLjUsNDEyLjQgLTI3OC41LDQxMi40IAkJIi8+DQoJCTxwb2x5Z29uIGNsYXNzPSJzdDAiIHBvaW50cz0iLTI2NC41LDQyOS40IC0yNzguNSw0MjkuNCAtMjc4LjUsNDA5LjQgLTI3MC41LDQwOS40IC0yNjQuNSw0MTUuNCAJCSIvPg0KCQk8cG9seWxpbmUgY2xhc3M9InN0MCIgcG9pbnRzPSItMjcwLjUsNDA5LjQgLTI3MC41LDQxNS40IC0yNjQuNSw0MTUuNCAJCSIvPg0KCTwvZz4NCjwvZz4NCjxnIGlkPSJJbnZpc2libGVfU2hhcGUiPg0KCTxyZWN0IHg9Ii0yODUiIHk9IjQwOC45IiBjbGFzcz0ic3QxIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/success-icon.2618a33.jpg";

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(278)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(397),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(359),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(265)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(380),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(377),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(366),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(395),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(363),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(365),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(394),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(261)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(375),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(390),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(367),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(404),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(403),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(381),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(247)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(357),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(354),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(262)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(376),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(371),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(270)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(388),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(393),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(379),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(382),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(378),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(355),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(259)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(373),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(400),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(391),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(251)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(362),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(405),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(268)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(385),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(277)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(396),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(370),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(368),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(398),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(392),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "showModal": _vm.showModal,
      "id": "modal-user"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "modal-header"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Szczegóły użytkownika")])]), _vm._v(" "), (_vm.account.payments_info) ? _c('template', {
    slot: "modal-body"
  }, [(_vm.account.payments_info.account_type !== 'company') ? _c('div', {
    staticClass: "col s12 left-align"
  }, [_c('h5', [_vm._v("Dane użytkownika:")]), _vm._v(" "), _c('div', [_vm._v("Imię i nazwisko: "), _c('b', [_vm._v(_vm._s(_vm.account.first_name) + " " + _vm._s(_vm.account.last_name))])]), _vm._v(" "), _c('div', [_vm._v("Pesel: "), _c('b', [_vm._v(_vm._s(_vm.account.payments_info.pesel))])]), _vm._v(" "), _c('div', [_vm._v("Telefon: "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.account.phone
    }
  }, [_vm._v(_vm._s(_vm.account.phone))])]), _vm._v(" "), _c('div', [_vm._v("E-mail: "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.account.email
    }
  }, [_vm._v(_vm._s(_vm.account.email))])])]) : _vm._e(), _vm._v(" "), (_vm.account.payments_info.account_type === 'company') ? _c('div', {
    staticClass: "col s12 left-align"
  }, [_c('h5', [_vm._v("Dane firmy:")]), _vm._v(" "), _c('div', [_vm._v("Nazwa: "), _c('b', [_vm._v(_vm._s(_vm.account.payments_info.company_name))])]), _vm._v(" "), _c('div', [_vm._v("NIP: "), _c('b', [_vm._v(_vm._s(_vm.account.payments_info.nip))])]), _vm._v(" "), _c('div', [_vm._v("Imię i nazwisko: "), _c('b', [_vm._v(_vm._s(_vm.account.first_name) + " " + _vm._s(_vm.account.last_name))])]), _vm._v(" "), _c('div', [_vm._v("Telefon: "), _c('a', {
    attrs: {
      "href": 'tel:' + _vm.account.phone
    }
  }, [_vm._v(_vm._s(_vm.account.phone))])]), _vm._v(" "), _c('div', [_vm._v("E-mail: "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.account.email
    }
  }, [_vm._v(_vm._s(_vm.account.email))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s12 left-align"
  }, [_c('h5', [_vm._v("Model rozliczeniowy")]), _vm._v(" "), _c('ul', {
    staticClass: "browser-default"
  }, [(_vm.account.settlement.cps) ? _c('li', [_vm._v("CPS: "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.account.settlement.cps)))])]) : _vm._e(), _vm._v(" "), (_vm.account.settlement.cpl) ? _c('li', [_vm._v("CPL: "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.account.settlement.cpl)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 left-align",
    attrs: {
      "id": "promotion-scope"
    }
  }, [_c('h5', [_vm._v("Sposób promocji")]), _vm._v(" "), _c('ul', {
    staticClass: "browser-default"
  }, [(_vm.account.website) ? _c('li', [_vm._v("strona internetowa: " + _vm._s(_vm.account.website_url))]) : _vm._e(), _vm._v(" "), (_vm.account.social_media) ? _c('li', [_vm._v("social media")]) : _vm._e(), _vm._v(" "), (_vm.account.marketing) ? _c('li', [_vm._v("marketing")]) : _vm._e(), _vm._v(" "), (_vm.account.email_marketing) ? _c('li', [_vm._v("email marketing")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 left-align"
  }, [_c('h5', [_vm._v("Ostatnia wypłacona transza:")]), _vm._v(" "), (_vm.account.tranches_info) ? _c('div', [_c('div', [_vm._v("Data: "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.account.tranches_info.created_at)))])]), _vm._v(" "), _c('div', [_vm._v("Nr transzy: "), _c('b', [_vm._v(_vm._s(_vm.account.tranches_info.token))])]), _vm._v(" "), _c('div', [_vm._v("Wartość: "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.account.tranches_info.amount)))])])]) : _c('div', [_vm._v("brak")])])]) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large btn-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "mfind-icon-back"
  }), _vm._v("\n      Zamknij\n    ")])]), _vm._v(" "), _c('template', {
    slot: "loader"
  }, [_c('Loader', {
    attrs: {
      "loading": this.data.loading
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "UserInvite"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('contact')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9"
  }, [_c('div', {
    staticClass: "card standard-card"
  }, [_c('h4', [_vm._v("Wypełnij brakujące informacje")]), _vm._v(" "), _c('AccountDetailsForm', {
    on: {
      "sendSuccess": _vm.showSuccessModal
    }
  })], 1)])]), _vm._v(" "), (_vm.showModal) ? _c('modal-success-account-details', {
    attrs: {
      "showModal": _vm.showModal
    },
    on: {
      "close": _vm.closeSuccessModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-with-us"
  }, [_c('h5', [_vm._v("Kontakt")]), _vm._v(" "), _c('a', {
    staticClass: "email",
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v("partnerzy@punkta.pl")]), _vm._v(" "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://dokumenty.punkta.pl/Regulamin-Programu-Partnerskiego-Punkta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Regulamin")])])
}]}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "showModal": _vm.showModal,
      "id": "tranche-details"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "modal-header"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Szczegóły wpłaty " + _vm._s(_vm.tranche.token))])]), _vm._v(" "), _c('template', {
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "saldo"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm._f("currency")(_vm.tranche.amount)
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Kwota wynagrodzenia")])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "inside-line"
  }, [_vm._v("\n        Dane do wysłania\n      ")])]), _vm._v(" "), _c('invoice-details', {
    attrs: {
      "token": _vm.tranche.token
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line status-changes-details"
  }, [_c('div', {
    staticClass: "inside-line"
  }, [_vm._v("\n        Szczegóły aktualizacji statusu\n      ")])]), _vm._v(" "), _c('table', {
    staticClass: "highlight centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data aktualizacji")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tranche.changes), function(change) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("date")(change.updated_at)) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(change.status))])])
  }), 0)])], 1), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "mfind-icon-back"
  }), _vm._v(" Zamknij\n    ")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-field"
  }, [_c('label', {
    class: {
      active: !!_vm.value
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('input', {
    class: {
      'invalid': !!_vm.errors
    },
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "required": _vm.required,
      "pattern": _vm.pattern
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.change
    }
  }), _vm._v(" "), _c('error-message', {
    attrs: {
      "errors": _vm.errors
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-info banner-wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-field",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.size))]), _vm._v(" "), _c('div', {
    staticClass: "input-field"
  }, [_c('input', {
    staticClass: "input-with-btn",
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "readonly": ""
    },
    domProps: {
      "value": ("<a href=\"" + _vm.url + "?mpc=" + _vm.utm_medium + "&utm_medium=" + _vm.utm_medium + "&utm_source=" + _vm.utm_source + "&utm_brand=" + _vm.utm_brand + "&utm_campaign=" + _vm.utm_campaign + "&utm_content=" + _vm.size + "\" target=\"_blank\" rel=\"dofollow\"><img src=\"" + _vm.imageUrl + "\" alt=\"Punkta.pl – porównywarka OC\"></a>")
    },
    on: {
      "focus": _vm.select
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-flat btn-copy",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.copyUrl
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(33)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "banner-image",
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.errors) ? _c('div', {
    staticClass: "error-info red-text"
  }, [_c('i', {
    staticClass: "mfind-icon-x"
  }), _vm._v(_vm._s(_vm.errors.join(', ')) + "\n")]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row user-data"
  }, [_c('div', {
    staticClass: "col s5 l12 user-avatar"
  }, [_c('img', {
    staticClass: "circle responsive-img",
    attrs: {
      "src": _vm.avatarUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col s7 l12 user-info"
  }, [_c('span', {
    staticClass: "full-name"
  }, [_c('span', {
    staticClass: "first-name"
  }, [_vm._v(_vm._s(_vm.getUser.first_name))]), _vm._v(" "), _c('span', {
    staticClass: "last-name"
  }, [_vm._v(_vm._s(_vm.getUser.last_name))])]), _vm._v(" "), _c('p', {
    staticClass: "user-email"
  }, [_vm._v(_vm._s(_vm.getUser.email))])]), _vm._v(" "), (!_vm.showForRole('accountant')) ? _c('div', {
    staticClass: "col s12 m12 l12 share-code"
  }, [_vm._m(0), _vm._v(" "), _c('input-promo-url', {
    attrs: {
      "type": "text",
      "name": "promo_url",
      "label": "Kod do promowania"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getUserPending,
      "type": ""
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "mfind-icon-info icon"
  }), _vm._v("\n      Link do produktu\n    ")])
}]}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "TranchesPage"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9 "
  }, [_c('div', {
    staticClass: "card standard-card stats-card"
  }, [_c('list-tranches')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [(!_vm.isLoggedIn) ? _c('h1', {
    staticClass: "center-align"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://mfind-production.s3.eu-central-1.amazonaws.com/images/punkta_white.png",
      "alt": "punkta"
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('nav', [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://mfind-production.s3.eu-central-1.amazonaws.com/images/punkta_white.png",
      "alt": "punkta"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-links hide-on-med-and-down"
  }, _vm._l((_vm.navLinks), function(link) {
    return _c('router-link', {
      key: link.routerName,
      attrs: {
        "to": {
          name: link.routerName
        },
        "active-class": "active",
        "exact": ""
      }
    }, [_vm._v("\n          " + _vm._s(link.name) + "\n        ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "menu-right"
  }, [(_vm.showSpecialToolsLink) ? _c('div', {
    staticClass: "money-and-share-link left"
  }, [_c('money-info', {
    staticClass: "left"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": {
        name: 'tools'
      }
    }
  }, [_vm._v("NARZĘDZIA")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "btn btn-overlay btn-logout hide-on-med-and-down",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Wyloguj")]), _vm._v(" "), _vm._m(0)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('ul', {
    staticClass: "slide-nav fixed right hide-on-large-only show-on-medium-and-down",
    attrs: {
      "id": "slide-out-nav"
    }
  }, [_c('li', {
    staticClass: "no-divider"
  }, [_c('a', {
    staticClass: "btn btn-overlay btn-logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Wyloguj")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.showSpecialToolsLink) ? _c('li', {
    staticClass: "money-container no-divider"
  }, [_c('money-info', {
    staticClass: "left"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn right",
    attrs: {
      "to": {
        name: 'tools'
      }
    }
  }, [_vm._v("NARZĘDZIA")])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "no-divider"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1)]), _vm._v(" "), _vm._l((_vm.navLinks), function(link) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: link.routerName
        },
        "active-class": "active",
        "exact": ""
      }
    }, [_vm._v("\n        " + _vm._s(link.name) + "\n      ")])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "no-divider"
  }, [_c('contact')], 1), _vm._v(" "), _c('li', {
    staticClass: "no-divider"
  }, [_c('find-us')], 1)], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button-collapse right show-on-medium-and-down",
    attrs: {
      "href": "#",
      "data-activates": "slide-out-nav"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-menu"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-close"
  })])
}]}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container center",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("modal-header", [_c('h5', {
    staticClass: "bold"
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("modal-body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer")], 2), _vm._v(" "), _vm._t("loader")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-field"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-with-btn",
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "readonly": ""
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "focus": _vm.select
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-flat btn-copy",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.copyPromoUrl()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(33)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn--full-width btn--cta-red",
    attrs: {
      "href": this.getPromoUrl,
      "target": "_blank"
    }
  }, [_vm._v("Kalkuluj")])
},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-with-us"
  }, [_c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://dokumenty.punkta.pl/Punkta-przewodnik-programu-partnerskiego.pdf",
      "target": "_blank"
    }
  }, [_c('h5', [_vm._v("Przewodnik po Programie Partnerskim Punkta")])]), _vm._v(" "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://dokumenty.punkta.pl/Punkta-przewodnik-programu-partnerskiego.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Pobierz PDF")])])
}]}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', [(!_vm.data.success) ? _c('div', {
    staticClass: "pass-reset-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Ustaw nowe hasło")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Wpisz w poniższym polu nowe hasło,"), _c('br'), _vm._v("\n      którym chcesz się logować do Twojego panelu.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Twoje nowe hasło:")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Wystąpił nieoczekiwany błąd aplikacji")])]) : _vm._e(), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Nowe hasło",
      "required": "true",
      "errors": _vm.data.errors['password']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password'] = val; }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "label": "Powtórz hasło",
      "required": "true",
      "errors": _vm.data.errors['password_confirmation']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password_confirmation'] = val; }
    },
    model: {
      value: (_vm.data.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.data, "password_confirmation", $$v)
      },
      expression: "data.password_confirmation"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zapisz nowe hasło")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])]), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-us-container"
  }, [_c('h5', [_vm._v("Znajdź nas!")]), _vm._v(" "), _c('div', {
    staticClass: "social-boxes"
  }, [_c('a', {
    staticClass: "social-box",
    attrs: {
      "href": "https://www.facebook.com/Punkta",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-fb"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-box",
    attrs: {
      "href": "https://www.linkedin.com/company/mfind",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-linkedin"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social-box",
    attrs: {
      "href": "https://www.wykop.pl/ludzie/mfind/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-wykop"
  })])])])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "in-out"
    }
  }, [(_vm.getTranches.length || _vm.getTranchesPending) ? _c('div', {
    staticClass: "promotor-tranches"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('h2', {
    staticClass: "col s12 m6"
  }, [_vm._v("Historia wypłat")])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', {
    staticClass: "responsive-table highlight centered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nr transzy"), _c('span', {
    staticClass: "hide-on-med-and-down"
  }, [_c('br'), _vm._v("(tytuł faktury/rachunku)")])]), _vm._v(" "), _c('th', [_vm._v("Wartość")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Data utworzenia")]), _vm._v(" "), _c('th', [_vm._v("Zobacz"), _c('span', {
    staticClass: "hide-on-med-and-down"
  }, [_c('br'), _vm._v("szczegóły")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getTranches), function(trancheItem) {
    return _c('tr', {
      key: trancheItem.token
    }, [_c('td', [_vm._v(_vm._s(trancheItem.token))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(trancheItem.amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trancheItem.changes[0].status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(trancheItem.created_at)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openModal(trancheItem)
        }
      }
    }, [_c('i', {
      staticClass: "mfind-icon-search"
    })])])])
  }), 0)]), _vm._v(" "), (_vm.showModal) ? _c('modal-tranche-history', {
    attrs: {
      "tranche": _vm.tranche,
      "showModal": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getTranchesPending,
      "type": ""
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facture-data row"
  }, [_c('div', {
    staticClass: "col m12 s12 data-column"
  }, [_c('span', {
    staticClass: "title head"
  }, [_vm._v("TYTUŁ FAKTURY/RACHUNKU (NR TRANSZY):")]), _vm._v("\n    " + _vm._s(_vm.token) + "\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col m12 s12 data-column"
  }, [_c('span', {
    staticClass: "title head"
  }, [_vm._v("E-MAIL DO PRZESŁANIA FAKTUR/RACHUNKU:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("mailto:faktury@punkta.pl?subject=Transza nr: " + _vm.token)
    }
  }, [_vm._v("\n      faktury@punkta.pl\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col m12 s12 data-column"
  }, [_c('div', {
    staticClass: "col m12 s12 company-info"
  }, [_c('span', {
    staticClass: "title head"
  }, [_vm._v("DANE PUNKTA:")])]), _vm._v(" "), _c('div', {
    staticClass: "col m6 s12 company-info address"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Punkta sp. z o.o.")]), _vm._v(" "), _c('br'), _vm._v("\n      ul. Aleje Jerozolimskie 146D "), _c('br'), _vm._v("\n      02-305 Warszawa\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col m6 s12 company-info"
  }, [_c('span', {
    staticClass: "title left"
  }, [_vm._v("nr KRS:")]), _vm._v(" 0000488906 "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title left"
  }, [_vm._v("Regon:")]), _vm._v(" 147010378 "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title left"
  }, [_vm._v("NIP:")]), _vm._v(" 522-30-11-279\n    ")])])
}]}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-in-progress"
  }, [_c('Loader', {
    attrs: {
      "loading": true
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "duration": {
        enter: 0,
        leave: 500
      },
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader-container valign-wrapper center-align"
  }, [_c('div', {
    staticClass: "spinner-container"
  }, [_c('div', {
    staticClass: "preloader-wrapper active",
    class: [_vm.type]
  }, [_c('div', {
    staticClass: "spinner-layer"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "gap-patch"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('form-searcher', {
    attrs: {
      "label": "Token do odnalezienia",
      "dataTooltip": "Szukaj transzy",
      "buttonIcon": "mfind-icon-search"
    },
    on: {
      "submitAction": function($event) {
        return _vm.searchTranch()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('div', [_c('a', {
    class: _vm.buttonClose(),
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  }, [_vm._v("\n      Anuluj wyszukanie\n    ")])]), _vm._v(" "), ((_vm.isSearchDataExist === false) && _vm.search.length) ? _c('div', {
    staticClass: "error center-align"
  }, [_c('span', {
    staticClass: "red-text"
  }, [_vm._v("Nie odnaleziono transzy spełniającej kryteria wyszukania")])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "responsive-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(trancheItem) {
    return _c('tr', {
      key: trancheItem.token
    }, [_c('td', [_vm._v(_vm._s(trancheItem.token))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(trancheItem.amount)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trancheItem.account.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(trancheItem.status))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openModal(trancheItem)
        }
      }
    }, [_c('i', {
      staticClass: "mfind-icon-edit"
    })])])])
  }), 0)]), _vm._v(" "), (_vm.showModal) ? _c('modal-tranche', {
    attrs: {
      "showModal": _vm.showModal,
      "tranche": _vm.tranche,
      "id": "tranche-settings",
      "currentStatus": _vm.trancheStatus
    },
    on: {
      "close": function($event) {
        _vm.showModal = !_vm.showModal
      },
      "reloadTranches": _vm.reloadTranches
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectPagination.total_pages > 1) ? _c('ul', {
    staticClass: "pagination"
  }, [_c('div', {
    staticClass: "btn-groups-pagination",
    class: _vm.buttonHide(1)
  }, [_c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.firstPage()
      }
    }
  }, [_vm._v(" « ")]), _vm._v(" "), _c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.previousPage()
      }
    }
  }, [_vm._v(" ‹ ")])]), _vm._v(" "), _vm._l((_vm.selectPagination.total_pages), function(item) {
    return _c('li', {
      class: [(_vm.currentPage === item) ? 'active' : 'waves-effect'],
      on: {
        "click": function($event) {
          return _vm.setPage(item)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-groups-pagination",
    class: _vm.buttonHide(_vm.selectPagination.total_pages)
  }, [_c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_vm._v(" › ")]), _vm._v(" "), _c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.lastPage()
      }
    }
  }, [_vm._v(" » ")])])], 2) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getTranchesPending,
      "type": ""
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Token")]), _vm._v(" "), _c('th', [_vm._v("Wartość")]), _vm._v(" "), _c('th', [_vm._v("Email"), _c('br'), _vm._v("użytkownika")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Zmień status")])])])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getPaymentSaldo !== false) ? _c('div', {
    staticClass: "money-info"
  }, [_c('div', {
    staticClass: "money-header-info"
  }, [_vm._v("Twoje środki")]), _vm._v(" "), _c('div', {
    staticClass: "money-amount"
  }, [_c('i', {
    staticClass: "mfind-icon-info"
  }), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.getPaymentSaldo)))])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Wysyłanie formularza z danymi do beneficjenta")]), _vm._v(" "), _c('form-searcher', {
    attrs: {
      "label": "Email beneficjenta",
      "buttonIcon": "mfind-icon-send",
      "dataTooltip": "Wyślij email do beneficjenta"
    },
    on: {
      "submitAction": function($event) {
        return _vm.buttonSendEmail()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.responseMessage) ? _c('div', {
    staticClass: "response"
  }, [_c('h5', [_vm._v(_vm._s(_vm.responseMessage))])]) : _vm._e()]), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.loading,
      "type": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', {
    staticClass: "confirm-email-page center-align"
  }, [(!_vm.data.success) ? _c('div', [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Weryfikacja adresu e-mail")]), _vm._v(" "), (_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('p', {
    staticClass: "card-subtitle center-align red-text"
  }, [_vm._v("\n        " + _vm._s(_vm.data.errors['message'].join(', ')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.data.errors['email']) ? _c('p', {
    staticClass: "card-subtitle center-align red-text"
  }, [_vm._v("\n        " + _vm._s(_vm.data.errors['email'].join(', ')) + "\n      ")]) : _c('p', {
    staticClass: "card-subtitle center-align red-text"
  }, [_vm._v("\n        Niestety nie udało nam się potwierdzić Twojego adresu email.\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_vm._v("\n          Napisz do nas\n        ")])])]) : _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Weryfikacja Twojego adresu e-mail w toku...\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])]) : _vm._e(), _vm._v(" "), (_vm.data.success) ? _c('div', [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Gratulacje!")]), _vm._v(" "), (_vm.data.message) ? _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      " + _vm._s(_vm.data.message) + "\n    ")]) : _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Twój e-mail został poprawnie zweryfikowany!\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.auth()
      }
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_vm._v("\n        Przejdź do aplikacji\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])]) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row user-stats"
  }, [_c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-send",
      "stats": _vm.getCalculations.started
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Rozpoczęte kalkulacje")])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-list",
      "stats": _vm.getCalculations.completed
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Zakończone kalkulacje")])])], 2)], 1), _vm._v(" "), (_vm.showStatsFor('cpl')) ? _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-doc",
      "stats": _vm.getCalculations.phone_confirmed
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Potwierdzone kalkulacje")])])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showStatsFor('cps')) ? _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-doc",
      "stats": _vm.getCalculations.sold_policies
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Sprzedane polisy")])])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6 l3 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm.getPayment.saldo,
      "unit": "zł"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Twoje środki")])])], 2)], 1), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getPending
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card banner standard-card"
  }, [_c('h4', [_vm._v("Pobierz banery AC/OC")]), _vm._v(" "), _c('p', [_vm._v("Skopiuj kod banera i wklej na swoją stronę.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--full-width btn--cta-red",
    class: {
      active: _vm.isAc
    },
    on: {
      "click": function($event) {
        _vm.isAc = !_vm.isAc
      }
    }
  }, [(!_vm.isAc) ? _c('span', [_vm._v("Pokaż banery")]) : _c('span', [_vm._v("Ukryj banery")])]), _vm._v(" "), (_vm.isAc) ? _c('div', {
    staticClass: "banner-row"
  }, [_c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x125px v1",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x125px v2",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x125px v3",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x250px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x250.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "468x60px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_468x60.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "540x30px_v1",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "540x30px_v2",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "540x30px_v3",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "728x90px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_728x90.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "750x200px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_750x200.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "160x600px",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_160x600.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x600px_v1",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x600.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac",
      "size": "300x600px_v2",
      "utm_campaign": "auto",
      "utm_source": "partnerski",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x600-1.jpg"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card banner standard-card"
  }, [_c('h4', [_vm._v("Pobierz banery Travel")]), _vm._v(" "), _c('p', [_vm._v("Skopiuj kod banera i wklej na swoją stronę.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--full-width btn--cta-red",
    class: {
      active: _vm.isTravel
    },
    on: {
      "click": function($event) {
        _vm.isTravel = !_vm.isTravel
      }
    }
  }, [(!_vm.isTravel) ? _c('span', [_vm._v("Pokaż banery")]) : _c('span', [_vm._v("Ukryj banery")])]), _vm._v(" "), (_vm.isTravel) ? _c('div', {
    staticClass: "banner-row"
  }, [_c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "160x600px_v1",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "160x600px_v2",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "160x600px_v3",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "300x250px_v1",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "300x250px_v2",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "300x250px_v3",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w3.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "750x100px_v1",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w1.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "750x100px_v2",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w2.jpg"
    }
  }), _vm._v(" "), _c('banner-url', {
    attrs: {
      "type": "text",
      "name": "baner_url",
      "label": "Baner do skopiowania",
      "url": "https://punkta.pl/ubezpieczenie-turystyczne/kalkulator",
      "size": "750x100px_v3",
      "utm_source": "partnerski",
      "utm_campaign": "travel",
      "utm_medium": ("" + _vm.getMpcCode),
      "utm_brand": "punkta",
      "imageUrl": "https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w3.jpg"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card standard-card"
  }, [_c('h4', [_vm._v("Porównywarka ubezpieczeń na Twojej stronie internetowej")]), _vm._v(" "), _c('p', [_vm._v("White Label to porównywarka ubezpieczeń komunikacyjnych pod Twoją marką. Jeśli posiadasz stronę www i chcesz wzbogacić ją o porównywarkę - napisz "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v("partnerzy@punkta.pl")]), _vm._v(". Modele rozliczenia do uzgodnienia: Revenue Share, CPO, CPS.")])])
}]}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "showModal": _vm.showModal,
      "id": "modal-tranches"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "modal-header"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Zmień status transzy")])]), _vm._v(" "), _c('template', {
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "col s12 left-align token-value"
  }, [_vm._v("Token: "), _c('span', [_vm._v(_vm._s(_vm.tranche.token))])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 left-align amount-value"
  }, [_vm._v("Wartość: "), _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.tranche.amount)))])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 left-align email-value"
  }, [_vm._v("User email: "), _c('span', [_vm._v(_vm._s(_vm.tranche.account.email))])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 status-change-value"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "browser-default",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.getStatuses), function(s) {
    return _c('option', {
      domProps: {
        "value": s.value
      }
    }, [_vm._v(_vm._s(s.name))])
  }), 0)])]), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large btn-first",
    on: {
      "click": function($event) {
        return _vm.changeStatus()
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon-save"
  }), _vm._v("\n      Zapisz\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-large btn-secondary",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "mfind-icon-back"
  }), _vm._v("\n      Zamknij\n    ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "in-out"
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "error center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Coś poszło nie tak, skontaktuj się z nami.")])]) : _vm._e()])], 1), _vm._v(" "), _c('template', {
    slot: "loader"
  }, [_c('Loader', {
    attrs: {
      "loading": this.data.loading
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', [_c('div', {
    staticClass: "check-inbox-page center-align"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89),
      "alt": "email wysłany"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Sprawdź skrzynkę")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle"
  }, [_vm._v("\n      Kliknij w link aktywacyjny,"), _c('br'), _vm._v("\n       aby w pełni korzystać ze swojego konta.\n    ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_c('i', {
    staticClass: "mfind-icon-back left"
  }), _vm._v("\n        Wróć do logowania\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'noauth': !_vm.isLoggedIn
    },
    attrs: {
      "id": "app"
    }
  }, [_c('header-bar', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', [(!_vm.data.success) ? _c('div', {
    staticClass: "pass-forgot-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Przypomnij hasło")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Podaj adres e-mail, którego uzyłeś do rejestracji."), _c('br'), _vm._v("\n      Wyślemy do Ciebie wiadomość z linkiem umożliwiającym ustawienie nowego hasła.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Wprowadź e-mail użyty przy rejestracji:")])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Użytkownik o podanym adresie e-mail nie istnieje")])]) : _vm._e(), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Adres e-mail",
      "required": "true",
      "errors": _vm.data.errors['email']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['email'] = val; }
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Przypomnij hasło")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])]) : _vm._e(), _vm._v(" "), (_vm.data.success) ? _c('div', {
    staticClass: "pass-forgot-page center-align"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(89),
      "alt": "email wysłany"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Sprawdź skrzynkę")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle"
  }, [_vm._v("\n      Nowe hasło zostało wysłane na podany przez Ciebie adres e-mail.\n    ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_c('i', {
    staticClass: "mfind-icon-back left"
  }), _vm._v("\n        Wróć do logowania\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])], 1) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "UsersPage"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9 "
  }, [_c('div', {
    staticClass: "card standard-card stats-card"
  }, [_c('list-users')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section container auth-page"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-align footer-rules"
  }, [_c('a', {
    attrs: {
      "href": "https://dokumenty.punkta.pl/Regulamin-Programu-Partnerskiego-Punkta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Regulamin")])])
}]}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', {
    staticClass: "login-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Logowanie")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("Zaloguj się, aby sprawdzić stan środków na Twoim koncie")]), _vm._v(" "), _c('div', {
    staticClass: "social-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Zaloguj się za pomocą:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 offset-m3"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-light red lighten-1",
    attrs: {
      "id": "google"
    },
    on: {
      "click": function($event) {
        return _vm.authorize('google_oauth2')
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon mfind-icon-google_white left"
  }), _vm._v(" "), _c('span', [_vm._v("Google")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("lub przy użyciu "), _c('br'), _vm._v("adresu email:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitLogin()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Nieprawidłowy login lub hasło, spróbuj ponownie")])]) : _vm._e(), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Adres e-mail",
      "required": "true"
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Hasło",
      "required": "true"
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zaloguj się")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n    Nie pamiętasz "), _c('router-link', {
    attrs: {
      "to": {
        name: 'passForgot'
      }
    }
  }, [_vm._v("hasła")]), _vm._v("?"), _c('br'), _vm._v("\n    Nie masz konta? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Zarejestruj się")]), _vm._v(" za darmo!\n  ")], 1), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row provision-table",
    class: _vm.showSettlementTypeClass()
  }, [_vm._m(0), _vm._v(" "), (_vm.showProvisionFor('cps')) ? _c('div', {
    staticClass: "col s12 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm.showProvisionFor('cps'),
      "unit": "zł"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', {
    staticClass: "provision-type-info"
  }, [_vm._v("\n          CPS\n          "), _c('span', {
    attrs: {
      "data-balloon-pos": "up",
      "data-balloon": "Sprzedana polisa"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-info icon"
  })])])])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showProvisionFor('cpl')) ? _c('div', {
    staticClass: "col s12 indicator-row"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm.showProvisionFor('cpl'),
      "unit": "zł"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', {
    staticClass: "provision-type-info"
  }, [_vm._v("\n          CPL\n          "), _c('span', {
    attrs: {
      "data-balloon-pos": "up",
      "data-balloon": "Potwierdzona kalkulacja"
    }
  }, [_c('i', {
    staticClass: "mfind-icon-info icon"
  })])])])], 2)], 1) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getUserPending
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col s12 headline center"
  }, [_c('h1', [_vm._v("Tabela wynagrodzeń")])])
}]}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-indicator"
  }, [_vm._t("header", [_c('h6', [_vm._v("Statystyki")])]), _vm._v(" "), _c('div', {
    staticClass: "indicator-text"
  }, [_c('div', {
    staticClass: "circle-icon"
  }, [_c('i', {
    class: _vm.icon
  })]), _vm._v(" "), _c('div', {
    staticClass: "stats-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.stats))]), _vm._v(" " + _vm._s(_vm.unit) + "\n    ")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('form-searcher', {
    attrs: {
      "label": "Email partnera do odnalezienia",
      "dataTooltip": "Szukaj użytkownika",
      "buttonIcon": "mfind-icon-search"
    },
    on: {
      "submitAction": function($event) {
        return _vm.searchUser()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('div', [_c('a', {
    class: _vm.buttonClose(),
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  }, [_vm._v("\n      Anuluj wyszukanie\n    ")])]), _vm._v(" "), ((_vm.isSearchDataExist === false) && _vm.search.length) ? _c('div', {
    staticClass: "error center-align"
  }, [_c('span', {
    staticClass: "red-text"
  }, [_vm._v("Nie odnaleziono partnera spełniającej kryteria wyszukania")])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "responsive-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(user.confirmation_date)))]), _vm._v(" "), _c('td', [_c('table', {
      staticClass: "statistic-table centered"
    }, [_vm._m(1, true), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(user.calculations.started))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.calculations.completed))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.calculations.phone_confirmed))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.calculations.sold_policies))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(user.payments.saldo, 2)))])])])])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn",
      on: {
        "click": function($event) {
          return _vm.openModal(user)
        }
      }
    }, [_c('i', {
      staticClass: "mfind-icon-search"
    })])])])
  }), 0)]), _vm._v(" "), (_vm.showModal) ? _c('modal-user', {
    attrs: {
      "showModal": _vm.showModal,
      "account": _vm.account,
      "id": "user-details"
    },
    on: {
      "close": function($event) {
        _vm.showModal = !_vm.showModal
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectPagination.total_pages > 1) ? _c('ul', {
    staticClass: "pagination"
  }, [_c('div', {
    staticClass: "btn-groups-pagination",
    class: _vm.buttonHide(1)
  }, [_c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.firstPage()
      }
    }
  }, [_vm._v(" « ")]), _vm._v(" "), _c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.previousPage()
      }
    }
  }, [_vm._v(" ‹ ")])]), _vm._v(" "), _vm._l((_vm.selectPagination.total_pages), function(item) {
    return _c('li', {
      class: [(_vm.currentPage === item) ? 'active' : 'waves-effect'],
      on: {
        "click": function($event) {
          return _vm.setPage(item)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-groups-pagination",
    class: _vm.buttonHide(_vm.selectPagination.total_pages)
  }, [_c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  }, [_vm._v(" › ")]), _vm._v(" "), _c('li', {
    staticClass: "btn btn-pagination waves-effect",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.lastPage()
      }
    }
  }, [_vm._v(" » ")])])], 2) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getListPending,
      "type": ""
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Data rejestracji")]), _vm._v(" "), _c('th', [_vm._v("Statystyki")]), _vm._v(" "), _c('th', [_vm._v("Szczegóły")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Rozpoczęte")]), _vm._v(" "), _c('th', [_vm._v("Zakończone")]), _vm._v(" "), _c('th', [_vm._v("Potwierdzone dane")]), _vm._v(" "), _c('th', [_vm._v("Sprzedane polisy")]), _vm._v(" "), _c('th', [_vm._v("Zebrane środki")])])])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "Mails"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9 "
  }, [_c('div', {
    staticClass: "card standard-card stats-card"
  }, [_c('complete-process')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', {
    staticClass: "register-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Rejestracja")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("Zarejestruj się jako agent Punkta")]), _vm._v(" "), _c('div', {
    staticClass: "social-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Zarejestruj się za pomocą:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 offset-m3"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-light red lighten-1",
    attrs: {
      "id": "google"
    },
    on: {
      "click": function($event) {
        return _vm.authorize('google_oauth2')
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon mfind-icon-google left"
  }), _vm._v(" "), _c('span', [_vm._v("Google")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("lub przy użyciu "), _c('br'), _vm._v("adresu email:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitRegister()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v("\n          " + _vm._s(_vm.data.errors['message'].join(', ')) + "\n        ")]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("\n          Rejestracja nie była możliwa, uzupełnij lub popraw zaznaczone pola\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "text",
      "name": "first_name",
      "label": "Imię",
      "required": "true",
      "errors": _vm.data.errors['first_name']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['first_name'] = val; }
    },
    model: {
      value: (_vm.data.first_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "first_name", $$v)
      },
      expression: "data.first_name"
    }
  }), _vm._v(" "), _c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "text",
      "name": "last_name",
      "label": "Nazwisko",
      "required": "true",
      "errors": _vm.data.errors['last_name']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['last_name'] = val; }
    },
    model: {
      value: (_vm.data.last_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "last_name", $$v)
      },
      expression: "data.last_name"
    }
  })], 1), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Adres e-mail",
      "required": "true",
      "errors": _vm.data.errors['email']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['email'] = val; }
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Hasło",
      "required": "true",
      "errors": _vm.data.errors['password']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password'] = val; }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  }), _vm._v(" "), _c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "label": "Powtórz hasło",
      "required": "true",
      "errors": _vm.data.errors['password_confirmation']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password_confirmation'] = val; }
    },
    model: {
      value: (_vm.data.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.data, "password_confirmation", $$v)
      },
      expression: "data.password_confirmation"
    }
  })], 1), _vm._v(" "), (_vm.data.parent_mpc_code) ? _c('input-field', {
    attrs: {
      "hidden": "",
      "name": "parent_mpc_code"
    },
    model: {
      value: (_vm.data.parent_mpc_code),
      callback: function($$v) {
        _vm.$set(_vm.data, "parent_mpc_code", $$v)
      },
      expression: "data.parent_mpc_code"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row col"
  }, [_vm._v("\n        Administratorem podanych danych osobowych będzie punkta sp. z o.o. Dane będą przetwarzane w celu zawarcia i\n        wykonania umowy uczestnictwa w programie partnerskim punkta.pl na zasadach określonych w\n        "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://punkta.pl/regulaminy/#regulamin-programu-partnerskiego-punkta-autoopen",
      "target": "_blank"
    }
  }, [_vm._v("Regulaminie")]), _vm._v(".\n        Czytaj więcej w\n        "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://punkta.pl/regulaminy/#polityka-prywatnosci-autoopen",
      "target": "_blank"
    }
  }, [_vm._v("Polityce prywatności")]), _vm._v(".\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zarejestruj się")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n    Masz już konto? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Zaloguj się")])], 1), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-chart"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('h2', {
    staticClass: "col s12 m6"
  }, [_vm._v("Historia kalkulacji")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSet),
      expression: "activeSet"
    }],
    staticClass: "stats-active-set browser-default",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeSet = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statSets), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0)])]), _vm._v(" "), _c('vue-chart', {
    staticClass: "col s12",
    attrs: {
      "chartType": _vm.chartType,
      "columns": _vm.columns,
      "rows": _vm.rows,
      "options": _vm.options,
      "language": "pl"
    }
  }), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getPendingHistory
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 l6"
  }, [_c('div', {
    staticClass: "input-field"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getPromoWidget),
      expression: "getPromoWidget"
    }],
    staticClass: "textarea-with-btn",
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.getPromoWidget)
    },
    on: {
      "focus": _vm.select,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.getPromoWidget = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-flat btn-copy",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.copyPromoWidget()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(33)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l6"
  }, [_c('div', {
    staticClass: "widget-box",
    domProps: {
      "innerHTML": _vm._s(_vm.getPromoWidget)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h4', [_vm._v("Dodawanie leada do procesu wypłat")]), _vm._v(" "), _c('form-searcher', {
    attrs: {
      "label": "SALESFORCE ID",
      "buttonIcon": "mfind-icon-send",
      "dataTooltip": "Wypłać środki dla beneficjenta"
    },
    on: {
      "submitAction": function($event) {
        return _vm.buttonProcessLead()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.responseMessage) ? _c('div', {
    staticClass: "response"
  }, [_c('h5', [_vm._v(_vm._s(_vm.responseMessage))])]) : _vm._e()]), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.loading,
      "type": ""
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "YourFunds"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('provision-table')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('contact')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9 "
  }, [(_vm.showModal) ? _c('modal-payout', {
    attrs: {
      "saldo": _vm.getPaymentSaldo,
      "showModal": _vm.showModal
    },
    on: {
      "close": _vm.toggleModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card standard-card stats-card"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "payout-accessories"
  }, [_c('button', {
    staticClass: "btn btn-payout",
    class: {
      disable: !_vm.getPayoutPossibility
    },
    on: {
      "click": function($event) {
        return _vm.isPaymentReady()
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon-money"
  }), _vm._v("\n               Wypłata wynagrodzenia\n            ")])])]), _vm._v(" "), _c('stats-grid')], 1), _vm._v(" "), _c('div', {
    staticClass: "card standard-card stats-card col s12 hide-on-large-only"
  }, [_c('provision-table')], 1), _vm._v(" "), _c('promotor-tranches', {
    staticClass: "card standard-card stats-card col s12"
  }), _vm._v(" "), _c('div', {
    staticClass: "card standard-card stats-card col s12"
  }, [_c('stats-chart', {
    attrs: {
      "chartType": 'AreaChart'
    }
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("Dokładne statystyki")])])
}]}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "account-details-form",
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inputs-container"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.formType),
      expression: "data.formType"
    }],
    staticClass: "with-gap",
    attrs: {
      "name": "formType",
      "type": "radio",
      "id": "form_type_person",
      "value": "person"
    },
    domProps: {
      "checked": _vm._q(_vm.data.formType, "person")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.data, "formType", "person")
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.formType),
      expression: "data.formType"
    }],
    staticClass: "with-gap",
    attrs: {
      "name": "formType",
      "type": "radio",
      "id": "form_type_company",
      "value": "company"
    },
    domProps: {
      "checked": _vm._q(_vm.data.formType, "company")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.data, "formType", "company")
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), (_vm.data.formType === 'person') ? _c('section', {
    attrs: {
      "id": "person"
    }
  }, [_c('h4', [_vm._v("Dane identyfikacyjne")]), _vm._v(" "), _c('div', {
    staticClass: "inputs-container"
  }, [_c('div', {
    staticClass: "col m6 s12"
  }, [_c('input-field', {
    attrs: {
      "type": "text",
      "name": "first_name",
      "label": "Imię",
      "required": "true",
      "errors": _vm.getError('first_name')
    },
    model: {
      value: (_vm.data.first_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "first_name", $$v)
      },
      expression: "data.first_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m6 s12"
  }, [_c('input-field', {
    attrs: {
      "type": "text",
      "name": "last_name",
      "label": "Nazwisko",
      "required": "true",
      "errors": _vm.getError('last_name')
    },
    model: {
      value: (_vm.data.last_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "last_name", $$v)
      },
      expression: "data.last_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col m6 s12"
  }, [_c('input-field', {
    attrs: {
      "type": "number",
      "name": "pesel",
      "label": "nr. PESEL",
      "required": "true",
      "errors": _vm.getError('pesel'),
      "pattern": "^\\d{11}$"
    },
    model: {
      value: (_vm.data.pesel),
      callback: function($$v) {
        _vm.$set(_vm.data, "pesel", $$v)
      },
      expression: "data.pesel"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.data.formType === 'company') ? _c('section', {
    attrs: {
      "id": "company"
    }
  }, [_c('h4', [_vm._v("Dane identyfikacyjne")]), _vm._v(" "), _c('div', {
    staticClass: "inputs-container"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('input-field', {
    attrs: {
      "type": "text",
      "name": "company_name",
      "label": "Nazwa firmy (dane płatnika na fakturze)",
      "required": "true",
      "errors": _vm.getError('company_name')
    },
    model: {
      value: (_vm.data.company_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "company_name", $$v)
      },
      expression: "data.company_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12"
  }, [_c('input-field', {
    attrs: {
      "type": "number",
      "name": "nip",
      "label": "Numer Identyfikacji Podatkowej",
      "required": "true",
      "errors": _vm.getError('nip')
    },
    model: {
      value: (_vm.data.nip),
      callback: function($$v) {
        _vm.$set(_vm.data, "nip", $$v)
      },
      expression: "data.nip"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "contact-data"
    }
  }, [_c('h4', [_vm._v("Dane kontaktowe")]), _vm._v(" "), _c('div', {
    staticClass: "inputs-container"
  }, [_c('div', {
    staticClass: "col m6 s12"
  }, [_c('input-field', {
    staticClass: "phone",
    attrs: {
      "type": "tel",
      "name": "phone",
      "label": "Telefon",
      "pattern": "^\\d{9}$",
      "errors": _vm.getError('contact_phone'),
      "required": "true"
    },
    model: {
      value: (_vm.data.phone),
      callback: function($$v) {
        _vm.$set(_vm.data, "phone", $$v)
      },
      expression: "data.phone"
    }
  })], 1)])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "agreements"
    }
  }, [_c('h4', [_vm._v("Zaakceptuj zgody")]), _vm._v(" "), _c('div', {
    staticClass: "inputs-container"
  }, [_c('div', {
    staticClass: "col s12"
  }, [_c('p', {
    staticClass: "m-10x0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.check_all_agreements),
      expression: "data.check_all_agreements"
    }],
    staticClass: "filled-in primary-color",
    attrs: {
      "type": "checkbox",
      "name": "check_all_agres",
      "id": "check_all_agres"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.check_all_agreements) ? _vm._i(_vm.data.check_all_agreements, null) > -1 : (_vm.data.check_all_agreements)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.data.check_all_agreements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "check_all_agreements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "check_all_agreements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "check_all_agreements", $$c)
        }
      }, _vm.checkAllAgreements]
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col s12"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agreements.data_truth_regulation.checked),
      expression: "data.agreements.data_truth_regulation.checked"
    }],
    staticClass: "filled-in primary-color",
    attrs: {
      "type": "checkbox",
      "name": "truth_regulation",
      "id": "truth_regulation",
      "required": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.agreements.data_truth_regulation.checked) ? _vm._i(_vm.data.agreements.data_truth_regulation.checked, null) > -1 : (_vm.data.agreements.data_truth_regulation.checked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.data.agreements.data_truth_regulation.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data.agreements.data_truth_regulation, "checked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data.agreements.data_truth_regulation, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data.agreements.data_truth_regulation, "checked", $$c)
        }
      }, function () { return _vm.triggerSingleAgreement('data_truth_regulation'); }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "truth_regulation"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.agreements.data_truth_regulation.text)
    }
  })])]), _vm._v(" "), _c('error-message', {
    attrs: {
      "errors": _vm.getError('data_truth_regulation', 'agreements')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agreements.online_agreement.checked),
      expression: "data.agreements.online_agreement.checked"
    }],
    staticClass: "filled-in primary-color",
    attrs: {
      "type": "checkbox",
      "name": "online_agreement",
      "id": "online_agreement",
      "required": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.agreements.online_agreement.checked) ? _vm._i(_vm.data.agreements.online_agreement.checked, null) > -1 : (_vm.data.agreements.online_agreement.checked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.data.agreements.online_agreement.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data.agreements.online_agreement, "checked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data.agreements.online_agreement, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data.agreements.online_agreement, "checked", $$c)
        }
      }, function () { return _vm.triggerSingleAgreement('online_agreement'); }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "online_agreement"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.agreements.online_agreement.text)
    }
  })])]), _vm._v(" "), _c('error-message', {
    attrs: {
      "errors": _vm.getError('online_agreement', 'agreements')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agreements.data_processing.checked),
      expression: "data.agreements.data_processing.checked"
    }],
    staticClass: "filled-in primary-color",
    attrs: {
      "type": "checkbox",
      "name": "data_processing",
      "id": "data_processing",
      "required": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.agreements.data_processing.checked) ? _vm._i(_vm.data.agreements.data_processing.checked, null) > -1 : (_vm.data.agreements.data_processing.checked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.data.agreements.data_processing.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data.agreements.data_processing, "checked", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data.agreements.data_processing, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data.agreements.data_processing, "checked", $$c)
        }
      }, function () { return _vm.triggerSingleAgreement('data_processing'); }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "data_processing"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.agreements.data_processing.text)
    }
  })])]), _vm._v(" "), _c('error-message', {
    attrs: {
      "errors": _vm.getError('data_processing', 'agreements')
    }
  })], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0 primary-color",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Wyślij")])]), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "form_type_person"
    }
  }, [_c('span', [_c('i', {
    staticClass: "large material-icons"
  }, [_vm._v("person")]), _vm._v("Osoba indywidualna")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "form_type_company"
    }
  }, [_c('i', {
    staticClass: "large material-icons"
  }, [_vm._v("business")]), _c('span', [_vm._v("Firma")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "check_all_agres"
    }
  }, [_c('span', [_vm._v("Zaznacz wszystkie zgody i oświadczenia")])])
}]}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', {
    staticClass: "register-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Rejestracja")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("Zarejestruj się i zarabiaj na polecaniu Punkta")]), _vm._v(" "), _c('div', {
    staticClass: "social-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Zarejestruj się za pomocą:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 offset-m3"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-light red lighten-1",
    attrs: {
      "id": "google"
    },
    on: {
      "click": function($event) {
        return _vm.authorize('google_oauth2')
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon mfind-icon-google left"
  }), _vm._v(" "), _c('span', [_vm._v("Google")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("lub przy użyciu "), _c('br'), _vm._v("adresu email:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitRegister()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v("\n          " + _vm._s(_vm.data.errors['message'].join(', ')) + "\n        ")]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("\n          Rejestracja nie była możliwa, uzupełnij lub popraw zaznaczone pola\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "text",
      "name": "first_name",
      "label": "Imię",
      "required": "true",
      "errors": _vm.data.errors['first_name']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['first_name'] = val; }
    },
    model: {
      value: (_vm.data.first_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "first_name", $$v)
      },
      expression: "data.first_name"
    }
  }), _vm._v(" "), _c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "text",
      "name": "last_name",
      "label": "Nazwisko",
      "required": "true",
      "errors": _vm.data.errors['last_name']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['last_name'] = val; }
    },
    model: {
      value: (_vm.data.last_name),
      callback: function($$v) {
        _vm.$set(_vm.data, "last_name", $$v)
      },
      expression: "data.last_name"
    }
  })], 1), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Adres e-mail",
      "required": "true",
      "errors": _vm.data.errors['email']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['email'] = val; }
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Hasło",
      "required": "true",
      "errors": _vm.data.errors['password']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password'] = val; }
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  }), _vm._v(" "), _c('input-field', {
    staticClass: "col s12 m6",
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "label": "Powtórz hasło",
      "required": "true",
      "errors": _vm.data.errors['password_confirmation']
    },
    on: {
      "updateError": function (val) { return _vm.data.errors['password_confirmation'] = val; }
    },
    model: {
      value: (_vm.data.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.data, "password_confirmation", $$v)
      },
      expression: "data.password_confirmation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row col"
  }, [_vm._v("\n        Administratorem podanych danych osobowych będzie punkta sp. z o.o. Dane będą przetwarzane w celu zawarcia i\n        wykonania umowy uczestnictwa w programie partnerskim punkta.pl na zasadach określonych w\n        "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://dokumenty.punkta.pl/Regulamin-Programu-Partnerskiego-Punkta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Regulaminie")]), _vm._v(".\n        Czytaj więcej w\n        "), _c('a', {
    staticClass: "rules",
    attrs: {
      "href": "https://punkta.pl/regulaminy/#polityka-prywatnosci-autoopen",
      "target": "_blank"
    }
  }, [_vm._v("Polityce prywatności")]), _vm._v(".\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zarejestruj się")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n    Masz już konto? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Zaloguj się")])], 1), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-field"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-with-btn",
    attrs: {
      "name": _vm.name,
      "id": _vm.name,
      "type": _vm.type,
      "readonly": ""
    },
    domProps: {
      "value": _vm.getPromoUrl
    },
    on: {
      "focus": _vm.select
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-flat btn-copy",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.copyPromoUrl()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(33)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "Mails"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9 "
  }, [_c('div', {
    staticClass: "card standard-card stats-card"
  }, [_c('beneficiary-mail-reminder')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-align",
    attrs: {
      "id": "homepage"
    }
  }, [_c('span', {
    staticClass: "white-text"
  }, [_vm._v("\n    Aby kontynuować musisz się zalogować:\n  ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)
},staticRenderFns: []}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "searcher-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searcher()
      }
    }
  }, [_c('div', {
    staticClass: "input-field"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "input-with-btn",
    attrs: {
      "type": "text",
      "id": "search"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-flat btn-search tooltipped",
    attrs: {
      "type": "submit",
      "data-delay": "50",
      "data-tooltip": _vm.dataTooltip
    }
  }, [_c('i', {
    class: _vm.buttonIcon
  })])])])
},staticRenderFns: []}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "showModal": _vm.showModal,
      "id": "modal-success"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "modal-header"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Witamy w Programie Partnerskim Punkta")])]), _vm._v(" "), _c('template', {
    slot: "modal-body"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(309)
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Jakie są następne kroki?")]), _vm._v(" "), _c('p', [_vm._v("Przejdź do swojego konta, skopiuj indywidualny link partnerski i zacznij promować ubezpieczenia Punkta.")])]), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Przejdź do panelu\n    ")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "showModal": _vm.showModal,
      "id": "modal-payout"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "modal-header"
  }, [_c('h5', {
    staticClass: "bold"
  }, [_vm._v("Wypłać wynagrodzenie")])]), _vm._v(" "), _c('template', {
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "payout-info"
  }, [(!_vm.data.tranche.token) ? _c('p', [_vm._v("\n        Gratulujemy! Suma środków na Twoim koncie partnerskim osiągnęła próg wypłaty.\n        Przejdź dalej, aby uzyskać niezbędne dane do zlecenia przelewu.\n      ")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "in-out"
    }
  }, [(_vm.data.tranche.token) ? _c('p', [_vm._v("\n          Aby wypłacić wynagrodzenie, wypełnij fakturę VAT (dla firm) lub rachunek (dla os. fizycznych)\n          na podstawie poniższych informacji\n          "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("i prześlij na adres\n            "), _c('a', {
    attrs: {
      "href": ("mailto:faktury@punkta.pl?subject=Transza nr: " + (_vm.data.tranche.token))
    }
  }, [_vm._v("faktury@punkta.pl")])])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "saldo"
  }, [_c('stats-indicator', {
    attrs: {
      "icon": "mfind-icon-wallet",
      "stats": _vm._f("currency")(_vm.trancheAmount())
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('h6', [_vm._v("Kwota wynagrodzenia")])])], 2)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "in-out"
    }
  }, [(_vm.data.tranche.token) ? _c('div', {
    staticClass: "second-page"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "inside-line"
  }, [_vm._v("\n            Dane do wysłania\n          ")])]), _vm._v(" "), _c('invoice-details', {
    attrs: {
      "token": _vm.data.tranche.token
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })], 1), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [(!_vm.data.tranche.token) ? _c('button', {
    staticClass: "btn btn-large btn-first",
    on: {
      "click": function($event) {
        return _vm.payout()
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon-money"
  }), _vm._v("\n      Wypłać\n    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-large",
    class: {
      'btn-secondary': !_vm.data.tranche.token
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon-back"
  }), _vm._v("\n      Zamknij\n    ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "in-out"
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "error center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Coś poszło nie tak, skontaktuj się z nami.")])]) : _vm._e()]), _vm._v(" "), (_vm.data.tranche.token) ? _c('p', {
    staticClass: "email-info"
  }, [_vm._v("\n      Dane zostały wysłane na Twój adres e-mail\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "loader"
  }, [_c('Loader', {
    attrs: {
      "loading": this.data.loading
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content row",
    attrs: {
      "id": "UserInvite"
    }
  }, [_c('div', {
    staticClass: "col s12 m11 main-page-content"
  }, [_c('div', {
    staticClass: "col l3 sidebar hide-on-med-and-down"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('user-info')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('contact')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('manual')], 1), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('find-us')], 1)]), _vm._v(" "), (_vm.isAgent) ? _c('div', {
    staticClass: "col s12 l9"
  }, [_c('div', {
    staticClass: "card standard-card"
  }, [_c('div', {
    staticClass: "share-info"
  }, [_c('h4', [_vm._v("Link do rejestracji dla współpracowników")]), _vm._v(" "), _c('p', [_vm._v("\n            Skopiuj link i wyślij do swoich współpracowników / agentów OFWCA, którzy będą dla Ciebie pracować.\n          ")]), _vm._v(" "), _c('input-copy-url', {
    attrs: {
      "type": "text",
      "name": "child_agent_registration_url",
      "label": "Link do rejestracji dla współpracowników",
      "value": _vm.child_agent_registration_url + _vm.getMpcCode
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col s12 l9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card standard-card"
  }, [_c('div', {
    staticClass: "share-info"
  }, [_c('h4', [_vm._v("Link do produktu")]), _vm._v(" "), (_vm.isAnyAgent) ? _c('p', [_vm._v("\n            Skopiuj link i zacznij promować porównywarkę ubezpieczeń komunikacyjnych Punkta.\n          ")]) : _c('p', [_vm._v("\n            Skopiuj link i zacznij promować porównywarkę ubezpieczeń komunikacyjnych Punkta na swojej stronie\n            internetowej, blogu, Youtube, Facebook oraz bazie mailingowej.\n          ")]), _vm._v(" "), _c('input-promo-url', {
    attrs: {
      "type": "text",
      "name": "promo_url",
      "label": "Kod do promowania"
    }
  }), _vm._v(" "), _c('calculate-button')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card standard-card"
  }, [_c('div', {
    staticClass: "share-info"
  }, [_c('h4', [_vm._v("Widget punkta")]), _vm._v(" "), (_vm.isAnyAgent) ? _c('p', [_vm._v("\n            Jeżeli masz swoją stronę Internetową skopiuj poniższy kod i wklej na stronę.\n          ")]) : _c('p', [_vm._v("\n            Skopiuj poniższy kod i wklej na swoją stronę."), _c('br'), _vm._v("Wszystkie kalkulacje oraz opłacone polisy\n            będą automatycznie zliczane i prezentowane w\n            "), _c('router-link', {
    attrs: {
      "to": {
        name: 'yourFunds'
      }
    }
  }, [_vm._v("profilu partnerskim")]), _vm._v("\n            .\n          ")], 1), _vm._v(" "), _c('textarea-promo-widget', {
    attrs: {
      "name": "promo_widget"
    }
  })], 1)]), _vm._v(" "), _c('Banners')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card highlighted-card"
  }, [_c('h4', [_vm._v("Jak to działa?")]), _vm._v(" "), _c('p', [_vm._v("\n          Każdy kto skutecznie poleci produkty Punkta otrzymuje wynagrodzenie."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Rozpocznij zarabiać na ubezpieczeniach!")]), _vm._v(" Dzięki naszym narzędziom i pomocy jest to\n          proste i efektywne! Nie musisz posiadać wiedzy informatycznej ani ubezpieczeniowej, zajmiemy się wszystkim!\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "cooperation-steps"
  }, [_c('div', {
    staticClass: "line hide-on-small-only"
  }), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    attrs: {
      "number": "1"
    }
  }, [_c('img', {
    staticClass: "inside-circle",
    attrs: {
      "src": __webpack_require__(308),
      "alt": "email wysłany"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-text"
  }, [_c('h5', {
    staticClass: "key-words"
  }, [_vm._v("Skopiuj link do produktu")])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "circle",
    attrs: {
      "number": "2"
    }
  }, [_c('img', {
    staticClass: "inside-circle",
    attrs: {
      "src": __webpack_require__(311),
      "alt": "email wysłany"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-text"
  }, [_c('h5', {
    staticClass: "key-words"
  }, [_vm._v("Promuj i polecaj")])])]), _vm._v(" "), _c('div', {
    staticClass: "step last-step"
  }, [_c('div', {
    staticClass: "circle last-circle",
    attrs: {
      "number": "3"
    }
  }, [_c('img', {
    staticClass: "inside-circle",
    attrs: {
      "src": __webpack_require__(310),
      "alt": "email wysłany"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-text"
  }, [_c('h5', {
    staticClass: "key-words"
  }, [_vm._v("Otrzymuj wynagrodzenie")])])])])])
}]}

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[121]);


// WEBPACK FOOTER //
// static/js/app.26acb98e2de26c20c55d.js